(() => {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $c2cbfd2eb3cfadf4$export$f082a360c4afba79 = (color)=>`
  <svg
    width=40
    height=40
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 5C29.1666 5 36.6666 10.9667 36.6666 18.3333C36.6666 25.7 29.1666 31.6667 20 31.6667C17.9333 31.6667 15.95 31.3667 14.1166 30.8333C9.24998 35 3.33331 35 3.33331 35C7.21665 31.1167 7.83331 28.5 7.91665 27.5C5.08331 25.1167 3.33331 21.8833 3.33331 18.3333C3.33331 10.9667 10.8333 5 20 5Z'
      fill=${color}
    />
  </svg>
`;


var $506efabaf57d4bc1$exports = {};
(function(global, factory) {
    factory($506efabaf57d4bc1$exports);
})($506efabaf57d4bc1$exports, function(exports1) {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _possibleConstructorReturn(self, call) {
        if (call && (typeof call === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(self);
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _superPropBase(object, property) {
        while(!Object.prototype.hasOwnProperty.call(object, property)){
            object = _getPrototypeOf(object);
            if (object === null) break;
        }
        return object;
    }
    function _get() {
        if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get.bind();
        else _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
            return desc.value;
        };
        return _get.apply(this, arguments);
    }
    function set(target, property, value, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.set) set = Reflect.set;
        else set = function set(target, property, value, receiver) {
            var base = _superPropBase(target, property);
            var desc;
            if (base) {
                desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.set) {
                    desc.set.call(receiver, value);
                    return true;
                } else if (!desc.writable) return false;
            }
            desc = Object.getOwnPropertyDescriptor(receiver, property);
            if (desc) {
                if (!desc.writable) return false;
                desc.value = value;
                Object.defineProperty(receiver, property, desc);
            } else _defineProperty(receiver, property, value);
            return true;
        };
        return set(target, property, value, receiver);
    }
    function _set(target, property, value, receiver, isStrict) {
        var s = set(target, property, value, receiver || target);
        if (!s && isStrict) throw new Error("failed to set property");
        return value;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    /**
    Provides details of changing model value
    @param {Object} [details]
    @param {string} [details.inserted] - Inserted symbols
    @param {boolean} [details.skip] - Can skip chars
    @param {number} [details.removeCount] - Removed symbols count
    @param {number} [details.tailShift] - Additional offset if any changes occurred before tail
  */ var ChangeDetails = /*#__PURE__*/ function() {
        /** Inserted symbols */ /** Can skip chars */ /** Additional offset if any changes occurred before tail */ /** Raw inserted is used by dynamic mask */ function ChangeDetails(details) {
            _classCallCheck(this, ChangeDetails);
            Object.assign(this, {
                inserted: "",
                rawInserted: "",
                skip: false,
                tailShift: 0
            }, details);
        }
        /**
      Aggregate changes
      @returns {ChangeDetails} `this`
    */ _createClass(ChangeDetails, [
            {
                key: "aggregate",
                value: function aggregate(details) {
                    this.rawInserted += details.rawInserted;
                    this.skip = this.skip || details.skip;
                    this.inserted += details.inserted;
                    this.tailShift += details.tailShift;
                    return this;
                }
            },
            {
                key: "offset",
                get: function get() {
                    return this.tailShift + this.inserted.length;
                }
            }
        ]);
        return ChangeDetails;
    }();
    /** Checks if value is string */ function isString(str) {
        return typeof str === "string" || str instanceof String;
    }
    /**
    Direction
    @prop {string} NONE
    @prop {string} LEFT
    @prop {string} FORCE_LEFT
    @prop {string} RIGHT
    @prop {string} FORCE_RIGHT
  */ var DIRECTION = {
        NONE: "NONE",
        LEFT: "LEFT",
        FORCE_LEFT: "FORCE_LEFT",
        RIGHT: "RIGHT",
        FORCE_RIGHT: "FORCE_RIGHT"
    };
    /** */ function forceDirection(direction) {
        switch(direction){
            case DIRECTION.LEFT:
                return DIRECTION.FORCE_LEFT;
            case DIRECTION.RIGHT:
                return DIRECTION.FORCE_RIGHT;
            default:
                return direction;
        }
    }
    /** Escapes regular expression control chars */ function escapeRegExp(str) {
        return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
    }
    function normalizePrepare(prep) {
        return Array.isArray(prep) ? prep : [
            prep,
            new ChangeDetails()
        ];
    } // cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
    function objectIncludes(b, a) {
        if (a === b) return true;
        var arrA = Array.isArray(a), arrB = Array.isArray(b), i;
        if (arrA && arrB) {
            if (a.length != b.length) return false;
            for(i = 0; i < a.length; i++){
                if (!objectIncludes(a[i], b[i])) return false;
            }
            return true;
        }
        if (arrA != arrB) return false;
        if (a && b && _typeof(a) === "object" && _typeof(b) === "object") {
            var dateA = a instanceof Date, dateB = b instanceof Date;
            if (dateA && dateB) return a.getTime() == b.getTime();
            if (dateA != dateB) return false;
            var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
            if (regexpA && regexpB) return a.toString() == b.toString();
            if (regexpA != regexpB) return false;
            var keys = Object.keys(a) // if (keys.length !== Object.keys(b).length) return false;
            ;
            for(i = 0; i < keys.length; i++){
                // $FlowFixMe ... ???
                if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            }
            for(i = 0; i < keys.length; i++){
                if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
            }
            return true;
        } else if (a && b && typeof a === "function" && typeof b === "function") return a.toString() === b.toString();
        return false;
    }
    /** Selection range */ /** Provides details of changing input */ var ActionDetails = /*#__PURE__*/ function() {
        /** Current input value */ /** Current cursor position */ /** Old input value */ /** Old selection */ function ActionDetails(value, cursorPos, oldValue, oldSelection) {
            _classCallCheck(this, ActionDetails);
            this.value = value;
            this.cursorPos = cursorPos;
            this.oldValue = oldValue;
            this.oldSelection = oldSelection // double check if left part was changed (autofilling, other non-standard input triggers)
            ;
            while(this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos))--this.oldSelection.start;
        }
        /**
      Start changing position
      @readonly
    */ _createClass(ActionDetails, [
            {
                key: "startChangePos",
                get: function get() {
                    return Math.min(this.cursorPos, this.oldSelection.start);
                }
            },
            {
                key: "insertedCount",
                get: function get() {
                    return this.cursorPos - this.startChangePos;
                }
            },
            {
                key: "inserted",
                get: function get() {
                    return this.value.substr(this.startChangePos, this.insertedCount);
                }
            },
            {
                key: "removedCount",
                get: function get() {
                    // Math.max for opposite operation
                    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
                    this.oldValue.length - this.value.length, 0);
                }
            },
            {
                key: "removed",
                get: function get() {
                    return this.oldValue.substr(this.startChangePos, this.removedCount);
                }
            },
            {
                key: "head",
                get: function get() {
                    return this.value.substring(0, this.startChangePos);
                }
            },
            {
                key: "tail",
                get: function get() {
                    return this.value.substring(this.startChangePos + this.insertedCount);
                }
            },
            {
                key: "removeDirection",
                get: function get() {
                    if (!this.removedCount || this.insertedCount) return DIRECTION.NONE // align right if delete at right
                    ;
                    return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
                    this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
                }
            }
        ]);
        return ActionDetails;
    }();
    /** Provides details of continuous extracted tail */ var ContinuousTailDetails = /*#__PURE__*/ function() {
        /** Tail value as string */ /** Tail start position */ /** Start position */ function ContinuousTailDetails() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var stop = arguments.length > 2 ? arguments[2] : undefined;
            _classCallCheck(this, ContinuousTailDetails);
            this.value = value;
            this.from = from;
            this.stop = stop;
        }
        _createClass(ContinuousTailDetails, [
            {
                key: "toString",
                value: function toString() {
                    return this.value;
                }
            },
            {
                key: "extend",
                value: function extend(tail) {
                    this.value += String(tail);
                }
            },
            {
                key: "appendTo",
                value: function appendTo(masked) {
                    return masked.append(this.toString(), {
                        tail: true
                    }).aggregate(masked._appendPlaceholder());
                }
            },
            {
                key: "state",
                get: function get() {
                    return {
                        value: this.value,
                        from: this.from,
                        stop: this.stop
                    };
                },
                set: function set(state) {
                    Object.assign(this, state);
                }
            },
            {
                key: "unshift",
                value: function unshift(beforePos) {
                    if (!this.value.length || beforePos != null && this.from >= beforePos) return "";
                    var shiftChar = this.value[0];
                    this.value = this.value.slice(1);
                    return shiftChar;
                }
            },
            {
                key: "shift",
                value: function shift() {
                    if (!this.value.length) return "";
                    var shiftChar = this.value[this.value.length - 1];
                    this.value = this.value.slice(0, -1);
                    return shiftChar;
                }
            }
        ]);
        return ContinuousTailDetails;
    }();
    /**
   * Applies mask on element.
   * @constructor
   * @param {HTMLInputElement|HTMLTextAreaElement|MaskElement} el - Element to apply mask
   * @param {Object} opts - Custom mask options
   * @return {InputMask}
   */ function IMask(el) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // currently available only for input-like elements
        return new IMask.InputMask(el, opts);
    }
    /** Supported mask type */ /** Provides common masking stuff */ var Masked = /*#__PURE__*/ function() {
        // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773
        /** @type {Mask} */ /** */ // $FlowFixMe no ideas
        /** Transforms value before mask processing */ /** Validates if value is acceptable */ /** Does additional processing in the end of editing */ /** Format typed value to string */ /** Parse strgin to get typed value */ /** Enable characters overwriting */ /** */ /** */ function Masked(opts) {
            _classCallCheck(this, Masked);
            this._value = "";
            this._update(Object.assign({}, Masked.DEFAULTS, opts));
            this.isInitialized = true;
        }
        /** Sets and applies new options */ _createClass(Masked, [
            {
                key: "updateOptions",
                value: function updateOptions(opts) {
                    if (!Object.keys(opts).length) return; // $FlowFixMe
                    this.withValueRefresh(this._update.bind(this, opts));
                }
            },
            {
                key: "_update",
                value: function _update(opts) {
                    Object.assign(this, opts);
                }
            },
            {
                key: "state",
                get: function get() {
                    return {
                        _value: this.value
                    };
                },
                set: function set(state) {
                    this._value = state._value;
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this._value = "";
                }
            },
            {
                key: "value",
                get: function get() {
                    return this._value;
                },
                set: function set(value) {
                    this.resolve(value);
                }
            },
            {
                key: "resolve",
                value: function resolve(value) {
                    this.reset();
                    this.append(value, {
                        input: true
                    }, "");
                    this.doCommit();
                    return this.value;
                }
            },
            {
                key: "unmaskedValue",
                get: function get() {
                    return this.value;
                },
                set: function set(value) {
                    this.reset();
                    this.append(value, {}, "");
                    this.doCommit();
                }
            },
            {
                key: "typedValue",
                get: function get() {
                    return this.doParse(this.value);
                },
                set: function set(value) {
                    this.value = this.doFormat(value);
                }
            },
            {
                key: "rawInputValue",
                get: function get() {
                    return this.extractInput(0, this.value.length, {
                        raw: true
                    });
                },
                set: function set(value) {
                    this.reset();
                    this.append(value, {
                        raw: true
                    }, "");
                    this.doCommit();
                }
            },
            {
                key: "isComplete",
                get: function get() {
                    return true;
                }
            },
            {
                key: "isFilled",
                get: function get() {
                    return this.isComplete;
                }
            },
            {
                key: "nearestInputPos",
                value: function nearestInputPos(cursorPos, direction) {
                    return cursorPos;
                }
            },
            {
                key: "extractInput",
                value: function extractInput() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    return this.value.slice(fromPos, toPos);
                }
            },
            {
                key: "extractTail",
                value: function extractTail() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
                }
            },
            {
                key: "appendTail",
                value: function appendTail(tail) {
                    if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
                    return tail.appendTo(this);
                }
            },
            {
                key: "_appendCharRaw",
                value: function _appendCharRaw(ch) {
                    if (!ch) return new ChangeDetails();
                    this._value += ch;
                    return new ChangeDetails({
                        inserted: ch,
                        rawInserted: ch
                    });
                }
            },
            {
                key: "_appendChar",
                value: function _appendChar(ch) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var checkTail = arguments.length > 2 ? arguments[2] : undefined;
                    var consistentState = this.state;
                    var details;
                    var _normalizePrepare = normalizePrepare(this.doPrepare(ch, flags));
                    var _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2);
                    ch = _normalizePrepare2[0];
                    details = _normalizePrepare2[1];
                    details = details.aggregate(this._appendCharRaw(ch, flags));
                    if (details.inserted) {
                        var consistentTail;
                        var appended = this.doValidate(flags) !== false;
                        if (appended && checkTail != null) {
                            // validation ok, check tail
                            var beforeTailState = this.state;
                            if (this.overwrite === true) {
                                consistentTail = checkTail.state;
                                checkTail.unshift(this.value.length);
                            }
                            var tailDetails = this.appendTail(checkTail);
                            appended = tailDetails.rawInserted === checkTail.toString() // not ok, try shift
                            ;
                            if (!(appended && tailDetails.inserted) && this.overwrite === "shift") {
                                this.state = beforeTailState;
                                consistentTail = checkTail.state;
                                checkTail.shift();
                                tailDetails = this.appendTail(checkTail);
                                appended = tailDetails.rawInserted === checkTail.toString();
                            } // if ok, rollback state after tail
                            if (appended && tailDetails.inserted) this.state = beforeTailState;
                        } // revert all if something went wrong
                        if (!appended) {
                            details = new ChangeDetails();
                            this.state = consistentState;
                            if (checkTail && consistentTail) checkTail.state = consistentTail;
                        }
                    }
                    return details;
                }
            },
            {
                key: "_appendPlaceholder",
                value: function _appendPlaceholder() {
                    return new ChangeDetails();
                }
            },
            {
                key: "_appendEager",
                value: function _appendEager() {
                    return new ChangeDetails();
                }
            },
            {
                key: "append",
                value: function append(str, flags, tail) {
                    if (!isString(str)) throw new Error("value should be string");
                    var details = new ChangeDetails();
                    var checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
                    if (flags !== null && flags !== void 0 && flags.tail) flags._beforeTailState = this.state;
                    for(var ci = 0; ci < str.length; ++ci)details.aggregate(this._appendChar(str[ci], flags, checkTail));
                     // append tail but aggregate only tailShift
                    if (checkTail != null) details.tailShift += this.appendTail(checkTail).tailShift // TODO it's a good idea to clear state after appending ends
                    ;
                    if (this.eager && flags !== null && flags !== void 0 && flags.input && str) details.aggregate(this._appendEager());
                    return details;
                }
            },
            {
                key: "remove",
                value: function remove() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
                    return new ChangeDetails();
                }
            },
            {
                key: "withValueRefresh",
                value: function withValueRefresh(fn) {
                    if (this._refreshing || !this.isInitialized) return fn();
                    this._refreshing = true;
                    var rawInput = this.rawInputValue;
                    var value = this.value;
                    var ret = fn();
                    this.rawInputValue = rawInput // append lost trailing chars at end
                    ;
                    if (this.value && this.value !== value && value.indexOf(this.value) === 0) this.append(value.slice(this.value.length), {}, "");
                    delete this._refreshing;
                    return ret;
                }
            },
            {
                key: "runIsolated",
                value: function runIsolated(fn) {
                    if (this._isolated || !this.isInitialized) return fn(this);
                    this._isolated = true;
                    var state = this.state;
                    var ret = fn(this);
                    this.state = state;
                    delete this._isolated;
                    return ret;
                }
            },
            {
                key: "doPrepare",
                value: function doPrepare(str) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    return this.prepare ? this.prepare(str, this, flags) : str;
                }
            },
            {
                key: "doValidate",
                value: function doValidate(flags) {
                    return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
                }
            },
            {
                key: "doCommit",
                value: function doCommit() {
                    if (this.commit) this.commit(this.value, this);
                }
            },
            {
                key: "doFormat",
                value: function doFormat(value) {
                    return this.format ? this.format(value, this) : value;
                }
            },
            {
                key: "doParse",
                value: function doParse(str) {
                    return this.parse ? this.parse(str, this) : str;
                }
            },
            {
                key: "splice",
                value: function splice(start, deleteCount, inserted, removeDirection) {
                    var flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                        input: true
                    };
                    var tailPos = start + deleteCount;
                    var tail = this.extractTail(tailPos);
                    var oldRawValue;
                    if (this.eager) {
                        removeDirection = forceDirection(removeDirection);
                        oldRawValue = this.extractInput(0, tailPos, {
                            raw: true
                        });
                    }
                    var startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !this.eager ? DIRECTION.NONE : removeDirection);
                    var details = new ChangeDetails({
                        tailShift: startChangePos - start // adjust tailShift if start was aligned
                    }).aggregate(this.remove(startChangePos));
                    if (this.eager && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
                        if (removeDirection === DIRECTION.FORCE_LEFT) {
                            var valLength;
                            while(oldRawValue === this.rawInputValue && (valLength = this.value.length))details.aggregate(new ChangeDetails({
                                tailShift: -1
                            })).aggregate(this.remove(valLength - 1));
                        } else if (removeDirection === DIRECTION.FORCE_RIGHT) tail.unshift();
                    }
                    return details.aggregate(this.append(inserted, flags, tail));
                }
            },
            {
                key: "maskEquals",
                value: function maskEquals(mask) {
                    return this.mask === mask;
                }
            },
            {
                key: "typedValueEquals",
                value: function typedValueEquals(value) {
                    var tval = this.typedValue;
                    return value === tval || Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval) || this.doFormat(value) === this.doFormat(this.typedValue);
                }
            }
        ]);
        return Masked;
    }();
    Masked.DEFAULTS = {
        format: function format(v) {
            return v;
        },
        parse: function parse(v) {
            return v;
        }
    };
    Masked.EMPTY_VALUES = [
        undefined,
        null,
        ""
    ];
    IMask.Masked = Masked;
    /** Get Masked class by mask type */ function maskedClass(mask) {
        if (mask == null) throw new Error("mask property should be defined");
         // $FlowFixMe
        if (mask instanceof RegExp) return IMask.MaskedRegExp // $FlowFixMe
        ;
        if (isString(mask)) return IMask.MaskedPattern // $FlowFixMe
        ;
        if (mask instanceof Date || mask === Date) return IMask.MaskedDate // $FlowFixMe
        ;
        if (mask instanceof Number || typeof mask === "number" || mask === Number) return IMask.MaskedNumber // $FlowFixMe
        ;
        if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic // $FlowFixMe
        ;
        if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask // $FlowFixMe
        ;
        if (mask instanceof IMask.Masked) return mask.constructor // $FlowFixMe
        ;
        if (mask instanceof Function) return IMask.MaskedFunction;
        console.warn("Mask not found for mask", mask) // eslint-disable-line no-console
        ;
        // $FlowFixMe
        return IMask.Masked;
    }
    /** Creates new {@link Masked} depending on mask type */ function createMask(opts) {
        // $FlowFixMe
        if (IMask.Masked && opts instanceof IMask.Masked) return opts;
        opts = Object.assign({}, opts);
        var mask = opts.mask // $FlowFixMe
        ;
        if (IMask.Masked && mask instanceof IMask.Masked) return mask;
        var MaskedClass = maskedClass(mask);
        if (!MaskedClass) throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
        return new MaskedClass(opts);
    }
    IMask.createMask = createMask;
    var _excluded$4 = [
        "mask"
    ];
    var DEFAULT_INPUT_DEFINITIONS = {
        0: /\d/,
        a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
        // http://stackoverflow.com/a/22075070
        "*": /./
    };
    /** */ var PatternInputDefinition = /*#__PURE__*/ function() {
        /** */ /** */ /** */ /** */ /** */ /** */ /** */ function PatternInputDefinition(opts) {
            _classCallCheck(this, PatternInputDefinition);
            var mask = opts.mask, blockOpts = _objectWithoutProperties(opts, _excluded$4);
            this.masked = createMask({
                mask: mask
            });
            Object.assign(this, blockOpts);
        }
        _createClass(PatternInputDefinition, [
            {
                key: "reset",
                value: function reset() {
                    this.isFilled = false;
                    this.masked.reset();
                }
            },
            {
                key: "remove",
                value: function remove() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    if (fromPos === 0 && toPos >= 1) {
                        this.isFilled = false;
                        return this.masked.remove(fromPos, toPos);
                    }
                    return new ChangeDetails();
                }
            },
            {
                key: "value",
                get: function get() {
                    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
                }
            },
            {
                key: "unmaskedValue",
                get: function get() {
                    return this.masked.unmaskedValue;
                }
            },
            {
                key: "isComplete",
                get: function get() {
                    return Boolean(this.masked.value) || this.isOptional;
                }
            },
            {
                key: "_appendChar",
                value: function _appendChar(ch) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (this.isFilled) return new ChangeDetails();
                    var state = this.masked.state // simulate input
                    ;
                    var details = this.masked._appendChar(ch, flags);
                    if (details.inserted && this.doValidate(flags) === false) {
                        details.inserted = details.rawInserted = "";
                        this.masked.state = state;
                    }
                    if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) details.inserted = this.placeholderChar;
                    details.skip = !details.inserted && !this.isOptional;
                    this.isFilled = Boolean(details.inserted);
                    return details;
                }
            },
            {
                key: "append",
                value: function append() {
                    var _this$masked;
                    // TODO probably should be done via _appendChar
                    return (_this$masked = this.masked).append.apply(_this$masked, arguments);
                }
            },
            {
                key: "_appendPlaceholder",
                value: function _appendPlaceholder() {
                    var details = new ChangeDetails();
                    if (this.isFilled || this.isOptional) return details;
                    this.isFilled = true;
                    details.inserted = this.placeholderChar;
                    return details;
                }
            },
            {
                key: "_appendEager",
                value: function _appendEager() {
                    return new ChangeDetails();
                }
            },
            {
                key: "extractTail",
                value: function extractTail() {
                    var _this$masked2;
                    return (_this$masked2 = this.masked).extractTail.apply(_this$masked2, arguments);
                }
            },
            {
                key: "appendTail",
                value: function appendTail() {
                    var _this$masked3;
                    return (_this$masked3 = this.masked).appendTail.apply(_this$masked3, arguments);
                }
            },
            {
                key: "extractInput",
                value: function extractInput() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    var flags = arguments.length > 2 ? arguments[2] : undefined;
                    return this.masked.extractInput(fromPos, toPos, flags);
                }
            },
            {
                key: "nearestInputPos",
                value: function nearestInputPos(cursorPos) {
                    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
                    var minPos = 0;
                    var maxPos = this.value.length;
                    var boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
                    switch(direction){
                        case DIRECTION.LEFT:
                        case DIRECTION.FORCE_LEFT:
                            return this.isComplete ? boundPos : minPos;
                        case DIRECTION.RIGHT:
                        case DIRECTION.FORCE_RIGHT:
                            return this.isComplete ? boundPos : maxPos;
                        case DIRECTION.NONE:
                        default:
                            return boundPos;
                    }
                }
            },
            {
                key: "doValidate",
                value: function doValidate() {
                    var _this$masked4, _this$parent;
                    return (_this$masked4 = this.masked).doValidate.apply(_this$masked4, arguments) && (!this.parent || (_this$parent = this.parent).doValidate.apply(_this$parent, arguments));
                }
            },
            {
                key: "doCommit",
                value: function doCommit() {
                    this.masked.doCommit();
                }
            },
            {
                key: "state",
                get: function get() {
                    return {
                        masked: this.masked.state,
                        isFilled: this.isFilled
                    };
                },
                set: function set(state) {
                    this.masked.state = state.masked;
                    this.isFilled = state.isFilled;
                }
            }
        ]);
        return PatternInputDefinition;
    }();
    var PatternFixedDefinition = /*#__PURE__*/ function() {
        /** */ /** */ /** */ /** */ /** */ /** */ function PatternFixedDefinition(opts) {
            _classCallCheck(this, PatternFixedDefinition);
            Object.assign(this, opts);
            this._value = "";
            this.isFixed = true;
        }
        _createClass(PatternFixedDefinition, [
            {
                key: "value",
                get: function get() {
                    return this._value;
                }
            },
            {
                key: "unmaskedValue",
                get: function get() {
                    return this.isUnmasking ? this.value : "";
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this._isRawInput = false;
                    this._value = "";
                }
            },
            {
                key: "remove",
                value: function remove() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
                    this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
                    if (!this._value) this._isRawInput = false;
                    return new ChangeDetails();
                }
            },
            {
                key: "nearestInputPos",
                value: function nearestInputPos(cursorPos) {
                    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
                    var minPos = 0;
                    var maxPos = this._value.length;
                    switch(direction){
                        case DIRECTION.LEFT:
                        case DIRECTION.FORCE_LEFT:
                            return minPos;
                        case DIRECTION.NONE:
                        case DIRECTION.RIGHT:
                        case DIRECTION.FORCE_RIGHT:
                        default:
                            return maxPos;
                    }
                }
            },
            {
                key: "extractInput",
                value: function extractInput() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
                    var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || "";
                }
            },
            {
                key: "isComplete",
                get: function get() {
                    return true;
                }
            },
            {
                key: "isFilled",
                get: function get() {
                    return Boolean(this._value);
                }
            },
            {
                key: "_appendChar",
                value: function _appendChar(ch) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var details = new ChangeDetails();
                    if (this._value) return details;
                    var appended = this.char === ch;
                    var isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !this.eager) && !flags.tail;
                    if (isResolved) details.rawInserted = this.char;
                    this._value = details.inserted = this.char;
                    this._isRawInput = isResolved && (flags.raw || flags.input);
                    return details;
                }
            },
            {
                key: "_appendEager",
                value: function _appendEager() {
                    return this._appendChar(this.char, {
                        tail: true
                    });
                }
            },
            {
                key: "_appendPlaceholder",
                value: function _appendPlaceholder() {
                    var details = new ChangeDetails();
                    if (this._value) return details;
                    this._value = details.inserted = this.char;
                    return details;
                }
            },
            {
                key: "extractTail",
                value: function extractTail() {
                    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    return new ContinuousTailDetails("");
                } // $FlowFixMe no ideas
            },
            {
                key: "appendTail",
                value: function appendTail(tail) {
                    if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
                    return tail.appendTo(this);
                }
            },
            {
                key: "append",
                value: function append(str, flags, tail) {
                    var details = this._appendChar(str[0], flags);
                    if (tail != null) details.tailShift += this.appendTail(tail).tailShift;
                    return details;
                }
            },
            {
                key: "doCommit",
                value: function doCommit() {}
            },
            {
                key: "state",
                get: function get() {
                    return {
                        _value: this._value,
                        _isRawInput: this._isRawInput
                    };
                },
                set: function set(state) {
                    Object.assign(this, state);
                }
            }
        ]);
        return PatternFixedDefinition;
    }();
    var _excluded$3 = [
        "chunks"
    ];
    var ChunksTailDetails = /*#__PURE__*/ function() {
        /** */ function ChunksTailDetails() {
            var chunks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            _classCallCheck(this, ChunksTailDetails);
            this.chunks = chunks;
            this.from = from;
        }
        _createClass(ChunksTailDetails, [
            {
                key: "toString",
                value: function toString() {
                    return this.chunks.map(String).join("");
                } // $FlowFixMe no ideas
            },
            {
                key: "extend",
                value: function extend(tailChunk) {
                    if (!String(tailChunk)) return;
                    if (isString(tailChunk)) tailChunk = new ContinuousTailDetails(String(tailChunk));
                    var lastChunk = this.chunks[this.chunks.length - 1];
                    var extendLast = lastChunk && // if stops are same or tail has no stop
                    (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
                    tailChunk.from === lastChunk.from + lastChunk.toString().length;
                    if (tailChunk instanceof ContinuousTailDetails) {
                        // check the ability to extend previous chunk
                        if (extendLast) // extend previous chunk
                        lastChunk.extend(tailChunk.toString());
                        else // append new chunk
                        this.chunks.push(tailChunk);
                    } else if (tailChunk instanceof ChunksTailDetails) {
                        if (tailChunk.stop == null) {
                            // unwrap floating chunks to parent, keeping `from` pos
                            var firstTailChunk;
                            while(tailChunk.chunks.length && tailChunk.chunks[0].stop == null){
                                firstTailChunk = tailChunk.chunks.shift();
                                firstTailChunk.from += tailChunk.from;
                                this.extend(firstTailChunk);
                            }
                        } // if tail chunk still has value
                        if (tailChunk.toString()) {
                            // if chunks contains stops, then popup stop to container
                            tailChunk.stop = tailChunk.blockIndex;
                            this.chunks.push(tailChunk);
                        }
                    }
                }
            },
            {
                key: "appendTo",
                value: function appendTo(masked) {
                    // $FlowFixMe
                    if (!(masked instanceof IMask.MaskedPattern)) {
                        var tail = new ContinuousTailDetails(this.toString());
                        return tail.appendTo(masked);
                    }
                    var details = new ChangeDetails();
                    for(var ci = 0; ci < this.chunks.length && !details.skip; ++ci){
                        var chunk = this.chunks[ci];
                        var lastBlockIter = masked._mapPosToBlock(masked.value.length);
                        var stop = chunk.stop;
                        var chunkBlock = void 0;
                        if (stop != null && // if block not found or stop is behind lastBlock
                        (!lastBlockIter || lastBlockIter.index <= stop)) {
                            if (chunk instanceof ChunksTailDetails || // for continuous block also check if stop is exist
                            masked._stops.indexOf(stop) >= 0) details.aggregate(masked._appendPlaceholder(stop));
                            chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
                        }
                        if (chunkBlock) {
                            var tailDetails = chunkBlock.appendTail(chunk);
                            tailDetails.skip = false // always ignore skip, it will be set on last
                            ;
                            details.aggregate(tailDetails);
                            masked._value += tailDetails.inserted // get not inserted chars
                            ;
                            var remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
                            if (remainChars) details.aggregate(masked.append(remainChars, {
                                tail: true
                            }));
                        } else details.aggregate(masked.append(chunk.toString(), {
                            tail: true
                        }));
                    }
                    return details;
                }
            },
            {
                key: "state",
                get: function get() {
                    return {
                        chunks: this.chunks.map(function(c) {
                            return c.state;
                        }),
                        from: this.from,
                        stop: this.stop,
                        blockIndex: this.blockIndex
                    };
                },
                set: function set(state) {
                    var chunks = state.chunks, props = _objectWithoutProperties(state, _excluded$3);
                    Object.assign(this, props);
                    this.chunks = chunks.map(function(cstate) {
                        var chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails() // $FlowFixMe already checked above
                        ;
                        chunk.state = cstate;
                        return chunk;
                    });
                }
            },
            {
                key: "unshift",
                value: function unshift(beforePos) {
                    if (!this.chunks.length || beforePos != null && this.from >= beforePos) return "";
                    var chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
                    var ci = 0;
                    while(ci < this.chunks.length){
                        var chunk = this.chunks[ci];
                        var shiftChar = chunk.unshift(chunkShiftPos);
                        if (chunk.toString()) {
                            // chunk still contains value
                            // but not shifted - means no more available chars to shift
                            if (!shiftChar) break;
                            ++ci;
                        } else // clean if chunk has no value
                        this.chunks.splice(ci, 1);
                        if (shiftChar) return shiftChar;
                    }
                    return "";
                }
            },
            {
                key: "shift",
                value: function shift() {
                    if (!this.chunks.length) return "";
                    var ci = this.chunks.length - 1;
                    while(0 <= ci){
                        var chunk = this.chunks[ci];
                        var shiftChar = chunk.shift();
                        if (chunk.toString()) {
                            // chunk still contains value
                            // but not shifted - means no more available chars to shift
                            if (!shiftChar) break;
                            --ci;
                        } else // clean if chunk has no value
                        this.chunks.splice(ci, 1);
                        if (shiftChar) return shiftChar;
                    }
                    return "";
                }
            }
        ]);
        return ChunksTailDetails;
    }();
    var PatternCursor = /*#__PURE__*/ function() {
        function PatternCursor(masked, pos) {
            _classCallCheck(this, PatternCursor);
            this.masked = masked;
            this._log = [];
            var _ref = masked._mapPosToBlock(pos) || (pos < 0 // first
             ? {
                index: 0,
                offset: 0
            } // last
             : {
                index: this.masked._blocks.length,
                offset: 0
            }), offset = _ref.offset, index = _ref.index;
            this.offset = offset;
            this.index = index;
            this.ok = false;
        }
        _createClass(PatternCursor, [
            {
                key: "block",
                get: function get() {
                    return this.masked._blocks[this.index];
                }
            },
            {
                key: "pos",
                get: function get() {
                    return this.masked._blockStartPos(this.index) + this.offset;
                }
            },
            {
                key: "state",
                get: function get() {
                    return {
                        index: this.index,
                        offset: this.offset,
                        ok: this.ok
                    };
                },
                set: function set(s) {
                    Object.assign(this, s);
                }
            },
            {
                key: "pushState",
                value: function pushState() {
                    this._log.push(this.state);
                }
            },
            {
                key: "popState",
                value: function popState() {
                    var s = this._log.pop();
                    this.state = s;
                    return s;
                }
            },
            {
                key: "bindBlock",
                value: function bindBlock() {
                    if (this.block) return;
                    if (this.index < 0) {
                        this.index = 0;
                        this.offset = 0;
                    }
                    if (this.index >= this.masked._blocks.length) {
                        this.index = this.masked._blocks.length - 1;
                        this.offset = this.block.value.length;
                    }
                }
            },
            {
                key: "_pushLeft",
                value: function _pushLeft(fn) {
                    this.pushState();
                    for(this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) === null || _this$block === void 0 ? void 0 : _this$block.value.length) || 0){
                        var _this$block;
                        if (fn()) return this.ok = true;
                    }
                    return this.ok = false;
                }
            },
            {
                key: "_pushRight",
                value: function _pushRight(fn) {
                    this.pushState();
                    for(this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0){
                        if (fn()) return this.ok = true;
                    }
                    return this.ok = false;
                }
            },
            {
                key: "pushLeftBeforeFilled",
                value: function pushLeftBeforeFilled() {
                    var _this = this;
                    return this._pushLeft(function() {
                        if (_this.block.isFixed || !_this.block.value) return;
                        _this.offset = _this.block.nearestInputPos(_this.offset, DIRECTION.FORCE_LEFT);
                        if (_this.offset !== 0) return true;
                    });
                }
            },
            {
                key: "pushLeftBeforeInput",
                value: function pushLeftBeforeInput() {
                    var _this2 = this;
                    // cases:
                    // filled input: 00|
                    // optional empty input: 00[]|
                    // nested block: XX<[]>|
                    return this._pushLeft(function() {
                        if (_this2.block.isFixed) return;
                        _this2.offset = _this2.block.nearestInputPos(_this2.offset, DIRECTION.LEFT);
                        return true;
                    });
                }
            },
            {
                key: "pushLeftBeforeRequired",
                value: function pushLeftBeforeRequired() {
                    var _this3 = this;
                    return this._pushLeft(function() {
                        if (_this3.block.isFixed || _this3.block.isOptional && !_this3.block.value) return;
                        _this3.offset = _this3.block.nearestInputPos(_this3.offset, DIRECTION.LEFT);
                        return true;
                    });
                }
            },
            {
                key: "pushRightBeforeFilled",
                value: function pushRightBeforeFilled() {
                    var _this4 = this;
                    return this._pushRight(function() {
                        if (_this4.block.isFixed || !_this4.block.value) return;
                        _this4.offset = _this4.block.nearestInputPos(_this4.offset, DIRECTION.FORCE_RIGHT);
                        if (_this4.offset !== _this4.block.value.length) return true;
                    });
                }
            },
            {
                key: "pushRightBeforeInput",
                value: function pushRightBeforeInput() {
                    var _this5 = this;
                    return this._pushRight(function() {
                        if (_this5.block.isFixed) return; // const o = this.offset;
                        _this5.offset = _this5.block.nearestInputPos(_this5.offset, DIRECTION.NONE) // HACK cases like (STILL DOES NOT WORK FOR NESTED)
                        ;
                        // aa|X
                        // aa<X|[]>X_    - this will not work
                        // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
                        return true;
                    });
                }
            },
            {
                key: "pushRightBeforeRequired",
                value: function pushRightBeforeRequired() {
                    var _this6 = this;
                    return this._pushRight(function() {
                        if (_this6.block.isFixed || _this6.block.isOptional && !_this6.block.value) return; // TODO check |[*]XX_
                        _this6.offset = _this6.block.nearestInputPos(_this6.offset, DIRECTION.NONE);
                        return true;
                    });
                }
            }
        ]);
        return PatternCursor;
    }();
    /** Masking by RegExp */ var MaskedRegExp = /*#__PURE__*/ function(_Masked) {
        _inherits(MaskedRegExp, _Masked);
        var _super = _createSuper(MaskedRegExp);
        function MaskedRegExp() {
            _classCallCheck(this, MaskedRegExp);
            return _super.apply(this, arguments);
        }
        _createClass(MaskedRegExp, [
            {
                key: "_update",
                value: /**
        @override
        @param {Object} opts
      */ function _update(opts) {
                    if (opts.mask) opts.validate = function(value) {
                        return value.search(opts.mask) >= 0;
                    };
                    _get(_getPrototypeOf(MaskedRegExp.prototype), "_update", this).call(this, opts);
                }
            }
        ]);
        return MaskedRegExp;
    }(Masked);
    IMask.MaskedRegExp = MaskedRegExp;
    var _excluded$2 = [
        "_blocks"
    ];
    /**
    Pattern mask
    @param {Object} opts
    @param {Object} opts.blocks
    @param {Object} opts.definitions
    @param {string} opts.placeholderChar
    @param {boolean} opts.lazy
  */ var MaskedPattern = /*#__PURE__*/ function(_Masked) {
        _inherits(MaskedPattern, _Masked);
        var _super = _createSuper(MaskedPattern);
        /** */ /** */ /** Single char for empty input */ /** Show placeholder only when needed */ function MaskedPattern() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, MaskedPattern);
            // TODO type $Shape<MaskedPatternOptions>={} does not work
            opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
            return _super.call(this, Object.assign({}, MaskedPattern.DEFAULTS, opts));
        }
        /**
      @override
      @param {Object} opts
    */ _createClass(MaskedPattern, [
            {
                key: "_update",
                value: function _update() {
                    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    opts.definitions = Object.assign({}, this.definitions, opts.definitions);
                    _get(_getPrototypeOf(MaskedPattern.prototype), "_update", this).call(this, opts);
                    this._rebuildMask();
                }
            },
            {
                key: "_rebuildMask",
                value: function _rebuildMask() {
                    var _this = this;
                    var defs = this.definitions;
                    this._blocks = [];
                    this._stops = [];
                    this._maskedBlocks = {};
                    var pattern = this.mask;
                    if (!pattern || !defs) return;
                    var unmaskingBlock = false;
                    var optionalBlock = false;
                    for(var i = 0; i < pattern.length; ++i){
                        if (this.blocks) {
                            var _ret = function() {
                                var p = pattern.slice(i);
                                var bNames = Object.keys(_this.blocks).filter(function(bName) {
                                    return p.indexOf(bName) === 0;
                                }) // order by key length
                                ;
                                bNames.sort(function(a, b) {
                                    return b.length - a.length;
                                }) // use block name with max length
                                ;
                                var bName = bNames[0];
                                if (bName) {
                                    // $FlowFixMe no ideas
                                    var maskedBlock = createMask(Object.assign({
                                        parent: _this,
                                        lazy: _this.lazy,
                                        eager: _this.eager,
                                        placeholderChar: _this.placeholderChar,
                                        overwrite: _this.overwrite
                                    }, _this.blocks[bName]));
                                    if (maskedBlock) {
                                        _this._blocks.push(maskedBlock) // store block index
                                        ;
                                        if (!_this._maskedBlocks[bName]) _this._maskedBlocks[bName] = [];
                                        _this._maskedBlocks[bName].push(_this._blocks.length - 1);
                                    }
                                    i += bName.length - 1;
                                    return "continue";
                                }
                            }();
                            if (_ret === "continue") continue;
                        }
                        var char = pattern[i];
                        var isInput = char in defs;
                        if (char === MaskedPattern.STOP_CHAR) {
                            this._stops.push(this._blocks.length);
                            continue;
                        }
                        if (char === "{" || char === "}") {
                            unmaskingBlock = !unmaskingBlock;
                            continue;
                        }
                        if (char === "[" || char === "]") {
                            optionalBlock = !optionalBlock;
                            continue;
                        }
                        if (char === MaskedPattern.ESCAPE_CHAR) {
                            ++i;
                            char = pattern[i];
                            if (!char) break;
                            isInput = false;
                        }
                        var def = isInput ? new PatternInputDefinition({
                            parent: this,
                            lazy: this.lazy,
                            eager: this.eager,
                            placeholderChar: this.placeholderChar,
                            mask: defs[char],
                            isOptional: optionalBlock
                        }) : new PatternFixedDefinition({
                            char: char,
                            eager: this.eager,
                            isUnmasking: unmaskingBlock
                        });
                        this._blocks.push(def);
                    }
                }
            },
            {
                key: "state",
                get: function get() {
                    return Object.assign({}, _get(_getPrototypeOf(MaskedPattern.prototype), "state", this), {
                        _blocks: this._blocks.map(function(b) {
                            return b.state;
                        })
                    });
                },
                set: function set(state) {
                    var _blocks = state._blocks, maskedState = _objectWithoutProperties(state, _excluded$2);
                    this._blocks.forEach(function(b, bi) {
                        return b.state = _blocks[bi];
                    });
                    _set(_getPrototypeOf(MaskedPattern.prototype), "state", maskedState, this, true);
                }
            },
            {
                key: "reset",
                value: function reset() {
                    _get(_getPrototypeOf(MaskedPattern.prototype), "reset", this).call(this);
                    this._blocks.forEach(function(b) {
                        return b.reset();
                    });
                }
            },
            {
                key: "isComplete",
                get: function get() {
                    return this._blocks.every(function(b) {
                        return b.isComplete;
                    });
                }
            },
            {
                key: "isFilled",
                get: function get() {
                    return this._blocks.every(function(b) {
                        return b.isFilled;
                    });
                }
            },
            {
                key: "isFixed",
                get: function get() {
                    return this._blocks.every(function(b) {
                        return b.isFixed;
                    });
                }
            },
            {
                key: "isOptional",
                get: function get() {
                    return this._blocks.every(function(b) {
                        return b.isOptional;
                    });
                }
            },
            {
                key: "doCommit",
                value: function doCommit() {
                    this._blocks.forEach(function(b) {
                        return b.doCommit();
                    });
                    _get(_getPrototypeOf(MaskedPattern.prototype), "doCommit", this).call(this);
                }
            },
            {
                key: "unmaskedValue",
                get: function get() {
                    return this._blocks.reduce(function(str, b) {
                        return str += b.unmaskedValue;
                    }, "");
                },
                set: function set(unmaskedValue) {
                    _set(_getPrototypeOf(MaskedPattern.prototype), "unmaskedValue", unmaskedValue, this, true);
                }
            },
            {
                key: "value",
                get: function get() {
                    // TODO return _value when not in change?
                    return this._blocks.reduce(function(str, b) {
                        return str += b.value;
                    }, "");
                },
                set: function set(value) {
                    _set(_getPrototypeOf(MaskedPattern.prototype), "value", value, this, true);
                }
            },
            {
                key: "appendTail",
                value: function appendTail(tail) {
                    return _get(_getPrototypeOf(MaskedPattern.prototype), "appendTail", this).call(this, tail).aggregate(this._appendPlaceholder());
                }
            },
            {
                key: "_appendEager",
                value: function _appendEager() {
                    var _this$_mapPosToBlock;
                    var details = new ChangeDetails();
                    var startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.value.length)) === null || _this$_mapPosToBlock === void 0 ? void 0 : _this$_mapPosToBlock.index;
                    if (startBlockIndex == null) return details // TODO test if it works for nested pattern masks
                    ;
                    if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
                    for(var bi = startBlockIndex; bi < this._blocks.length; ++bi){
                        var d = this._blocks[bi]._appendEager();
                        if (!d.inserted) break;
                        details.aggregate(d);
                    }
                    return details;
                }
            },
            {
                key: "_appendCharRaw",
                value: function _appendCharRaw(ch) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var blockIter = this._mapPosToBlock(this.value.length);
                    var details = new ChangeDetails();
                    if (!blockIter) return details;
                    for(var bi = blockIter.index;; ++bi){
                        var _flags$_beforeTailSta, _flags$_beforeTailSta2;
                        var _block = this._blocks[bi];
                        if (!_block) break;
                        var blockDetails = _block._appendChar(ch, Object.assign({}, flags, {
                            _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : (_flags$_beforeTailSta2 = _flags$_beforeTailSta._blocks) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2[bi]
                        }));
                        var skip = blockDetails.skip;
                        details.aggregate(blockDetails);
                        if (skip || blockDetails.rawInserted) break; // go next char
                    }
                    return details;
                }
            },
            {
                key: "extractTail",
                value: function extractTail() {
                    var _this2 = this;
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    var chunkTail = new ChunksTailDetails();
                    if (fromPos === toPos) return chunkTail;
                    this._forEachBlocksInRange(fromPos, toPos, function(b, bi, bFromPos, bToPos) {
                        var blockChunk = b.extractTail(bFromPos, bToPos);
                        blockChunk.stop = _this2._findStopBefore(bi);
                        blockChunk.from = _this2._blockStartPos(bi);
                        if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
                        chunkTail.extend(blockChunk);
                    });
                    return chunkTail;
                }
            },
            {
                key: "extractInput",
                value: function extractInput() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    if (fromPos === toPos) return "";
                    var input = "";
                    this._forEachBlocksInRange(fromPos, toPos, function(b, _, fromPos, toPos) {
                        input += b.extractInput(fromPos, toPos, flags);
                    });
                    return input;
                }
            },
            {
                key: "_findStopBefore",
                value: function _findStopBefore(blockIndex) {
                    var stopBefore;
                    for(var si = 0; si < this._stops.length; ++si){
                        var stop = this._stops[si];
                        if (stop <= blockIndex) stopBefore = stop;
                        else break;
                    }
                    return stopBefore;
                }
            },
            {
                key: "_appendPlaceholder",
                value: function _appendPlaceholder(toBlockIndex) {
                    var _this3 = this;
                    var details = new ChangeDetails();
                    if (this.lazy && toBlockIndex == null) return details;
                    var startBlockIter = this._mapPosToBlock(this.value.length);
                    if (!startBlockIter) return details;
                    var startBlockIndex = startBlockIter.index;
                    var endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
                    this._blocks.slice(startBlockIndex, endBlockIndex).forEach(function(b) {
                        if (!b.lazy || toBlockIndex != null) {
                            // $FlowFixMe `_blocks` may not be present
                            var args = b._blocks != null ? [
                                b._blocks.length
                            ] : [];
                            var bDetails = b._appendPlaceholder.apply(b, args);
                            _this3._value += bDetails.inserted;
                            details.aggregate(bDetails);
                        }
                    });
                    return details;
                }
            },
            {
                key: "_mapPosToBlock",
                value: function _mapPosToBlock(pos) {
                    var accVal = "";
                    for(var bi = 0; bi < this._blocks.length; ++bi){
                        var _block2 = this._blocks[bi];
                        var blockStartPos = accVal.length;
                        accVal += _block2.value;
                        if (pos <= accVal.length) return {
                            index: bi,
                            offset: pos - blockStartPos
                        };
                    }
                }
            },
            {
                key: "_blockStartPos",
                value: function _blockStartPos(blockIndex) {
                    return this._blocks.slice(0, blockIndex).reduce(function(pos, b) {
                        return pos += b.value.length;
                    }, 0);
                }
            },
            {
                key: "_forEachBlocksInRange",
                value: function _forEachBlocksInRange(fromPos) {
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    var fn = arguments.length > 2 ? arguments[2] : undefined;
                    var fromBlockIter = this._mapPosToBlock(fromPos);
                    if (fromBlockIter) {
                        var toBlockIter = this._mapPosToBlock(toPos) // process first block
                        ;
                        var isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
                        var fromBlockStartPos = fromBlockIter.offset;
                        var fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
                        fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
                        if (toBlockIter && !isSameBlock) {
                            // process intermediate blocks
                            for(var bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi)fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
                             // process last block
                            fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
                        }
                    }
                }
            },
            {
                key: "remove",
                value: function remove() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    var removeDetails = _get(_getPrototypeOf(MaskedPattern.prototype), "remove", this).call(this, fromPos, toPos);
                    this._forEachBlocksInRange(fromPos, toPos, function(b, _, bFromPos, bToPos) {
                        removeDetails.aggregate(b.remove(bFromPos, bToPos));
                    });
                    return removeDetails;
                }
            },
            {
                key: "nearestInputPos",
                value: function nearestInputPos(cursorPos) {
                    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
                    if (!this._blocks.length) return 0;
                    var cursor = new PatternCursor(this, cursorPos);
                    if (direction === DIRECTION.NONE) {
                        // -------------------------------------------------
                        // NONE should only go out from fixed to the right!
                        // -------------------------------------------------
                        if (cursor.pushRightBeforeInput()) return cursor.pos;
                        cursor.popState();
                        if (cursor.pushLeftBeforeInput()) return cursor.pos;
                        return this.value.length;
                    } // FORCE is only about a|* otherwise is 0
                    if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
                        // try to break fast when *|a
                        if (direction === DIRECTION.LEFT) {
                            cursor.pushRightBeforeFilled();
                            if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
                            cursor.popState();
                        } // forward flow
                        cursor.pushLeftBeforeInput();
                        cursor.pushLeftBeforeRequired();
                        cursor.pushLeftBeforeFilled() // backward flow
                        ;
                        if (direction === DIRECTION.LEFT) {
                            cursor.pushRightBeforeInput();
                            cursor.pushRightBeforeRequired();
                            if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                            cursor.popState();
                            if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                            cursor.popState();
                        }
                        if (cursor.ok) return cursor.pos;
                        if (direction === DIRECTION.FORCE_LEFT) return 0;
                        cursor.popState();
                        if (cursor.ok) return cursor.pos;
                        cursor.popState();
                        if (cursor.ok) return cursor.pos // cursor.popState();
                        ;
                        // if (
                        //   cursor.pushRightBeforeInput() &&
                        //   // TODO HACK for lazy if has aligned left inside fixed and has came to the start - use start position
                        //   (!this.lazy || this.extractInput())
                        // ) return cursor.pos;
                        return 0;
                    }
                    if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
                        // forward flow
                        cursor.pushRightBeforeInput();
                        cursor.pushRightBeforeRequired();
                        if (cursor.pushRightBeforeFilled()) return cursor.pos;
                        if (direction === DIRECTION.FORCE_RIGHT) return this.value.length // backward flow
                        ;
                        cursor.popState();
                        if (cursor.ok) return cursor.pos;
                        cursor.popState();
                        if (cursor.ok) return cursor.pos;
                        return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
                    }
                    return cursorPos;
                }
            },
            {
                key: "maskedBlock",
                value: function maskedBlock(name) {
                    return this.maskedBlocks(name)[0];
                }
            },
            {
                key: "maskedBlocks",
                value: function maskedBlocks(name) {
                    var _this4 = this;
                    var indices = this._maskedBlocks[name];
                    if (!indices) return [];
                    return indices.map(function(gi) {
                        return _this4._blocks[gi];
                    });
                }
            }
        ]);
        return MaskedPattern;
    }(Masked);
    MaskedPattern.DEFAULTS = {
        lazy: true,
        placeholderChar: "_"
    };
    MaskedPattern.STOP_CHAR = "`";
    MaskedPattern.ESCAPE_CHAR = "\\";
    MaskedPattern.InputDefinition = PatternInputDefinition;
    MaskedPattern.FixedDefinition = PatternFixedDefinition;
    IMask.MaskedPattern = MaskedPattern;
    /** Pattern which accepts ranges */ var MaskedRange = /*#__PURE__*/ function(_MaskedPattern) {
        _inherits(MaskedRange, _MaskedPattern);
        var _super = _createSuper(MaskedRange);
        function MaskedRange() {
            _classCallCheck(this, MaskedRange);
            return _super.apply(this, arguments);
        }
        _createClass(MaskedRange, [
            {
                key: "_matchFrom",
                get: /**
        Optionally sets max length of pattern.
        Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
      */ /** Min bound */ /** Max bound */ /** */ function get() {
                    return this.maxLength - String(this.from).length;
                }
            },
            {
                key: "_update",
                value: function _update(opts) {
                    // TODO type
                    opts = Object.assign({
                        to: this.to || 0,
                        from: this.from || 0,
                        maxLength: this.maxLength || 0
                    }, opts);
                    var maxLength = String(opts.to).length;
                    if (opts.maxLength != null) maxLength = Math.max(maxLength, opts.maxLength);
                    opts.maxLength = maxLength;
                    var fromStr = String(opts.from).padStart(maxLength, "0");
                    var toStr = String(opts.to).padStart(maxLength, "0");
                    var sameCharsCount = 0;
                    while(sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount])++sameCharsCount;
                    opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, "\\0") + "0".repeat(maxLength - sameCharsCount);
                    _get(_getPrototypeOf(MaskedRange.prototype), "_update", this).call(this, opts);
                }
            },
            {
                key: "isComplete",
                get: function get() {
                    return _get(_getPrototypeOf(MaskedRange.prototype), "isComplete", this) && Boolean(this.value);
                }
            },
            {
                key: "boundaries",
                value: function boundaries(str) {
                    var minstr = "";
                    var maxstr = "";
                    var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [], _ref2 = _slicedToArray(_ref, 3), placeholder = _ref2[1], num = _ref2[2];
                    if (num) {
                        minstr = "0".repeat(placeholder.length) + num;
                        maxstr = "9".repeat(placeholder.length) + num;
                    }
                    minstr = minstr.padEnd(this.maxLength, "0");
                    maxstr = maxstr.padEnd(this.maxLength, "9");
                    return [
                        minstr,
                        maxstr
                    ];
                } // TODO str is a single char everytime
            },
            {
                key: "doPrepare",
                value: function doPrepare(ch) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var details;
                    var _normalizePrepare = normalizePrepare(_get(_getPrototypeOf(MaskedRange.prototype), "doPrepare", this).call(this, ch.replace(/\D/g, ""), flags));
                    var _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2);
                    ch = _normalizePrepare2[0];
                    details = _normalizePrepare2[1];
                    if (!this.autofix || !ch) return ch;
                    var fromStr = String(this.from).padStart(this.maxLength, "0");
                    var toStr = String(this.to).padStart(this.maxLength, "0");
                    var nextVal = this.value + ch;
                    if (nextVal.length > this.maxLength) return "";
                    var _this$boundaries = this.boundaries(nextVal), _this$boundaries2 = _slicedToArray(_this$boundaries, 2), minstr = _this$boundaries2[0], maxstr = _this$boundaries2[1];
                    if (Number(maxstr) < this.from) return fromStr[nextVal.length - 1];
                    if (Number(minstr) > this.to) {
                        if (this.autofix === "pad" && nextVal.length < this.maxLength) return [
                            "",
                            details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))
                        ];
                        return toStr[nextVal.length - 1];
                    }
                    return ch;
                }
            },
            {
                key: "doValidate",
                value: function doValidate() {
                    var _get2;
                    var str = this.value;
                    var firstNonZero = str.search(/[^0]/);
                    if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
                    var _this$boundaries3 = this.boundaries(str), _this$boundaries4 = _slicedToArray(_this$boundaries3, 2), minstr = _this$boundaries4[0], maxstr = _this$boundaries4[1];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return this.from <= Number(maxstr) && Number(minstr) <= this.to && (_get2 = _get(_getPrototypeOf(MaskedRange.prototype), "doValidate", this)).call.apply(_get2, [
                        this
                    ].concat(args));
                }
            }
        ]);
        return MaskedRange;
    }(MaskedPattern);
    IMask.MaskedRange = MaskedRange;
    /** Date mask */ var MaskedDate = /*#__PURE__*/ function(_MaskedPattern) {
        _inherits(MaskedDate, _MaskedPattern);
        var _super = _createSuper(MaskedDate);
        /** Pattern mask for date according to {@link MaskedDate#format} */ /** Start date */ /** End date */ /** */ /**
      @param {Object} opts
    */ function MaskedDate(opts) {
            _classCallCheck(this, MaskedDate);
            return _super.call(this, Object.assign({}, MaskedDate.DEFAULTS, opts));
        }
        /**
      @override
    */ _createClass(MaskedDate, [
            {
                key: "_update",
                value: function _update(opts) {
                    if (opts.mask === Date) delete opts.mask;
                    if (opts.pattern) opts.mask = opts.pattern;
                    var blocks = opts.blocks;
                    opts.blocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS()) // adjust year block
                    ;
                    if (opts.min) opts.blocks.Y.from = opts.min.getFullYear();
                    if (opts.max) opts.blocks.Y.to = opts.max.getFullYear();
                    if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
                        opts.blocks.m.from = opts.min.getMonth() + 1;
                        opts.blocks.m.to = opts.max.getMonth() + 1;
                        if (opts.blocks.m.from === opts.blocks.m.to) {
                            opts.blocks.d.from = opts.min.getDate();
                            opts.blocks.d.to = opts.max.getDate();
                        }
                    }
                    Object.assign(opts.blocks, this.blocks, blocks) // add autofix
                    ;
                    Object.keys(opts.blocks).forEach(function(bk) {
                        var b = opts.blocks[bk];
                        if (!("autofix" in b) && "autofix" in opts) b.autofix = opts.autofix;
                    });
                    _get(_getPrototypeOf(MaskedDate.prototype), "_update", this).call(this, opts);
                }
            },
            {
                key: "doValidate",
                value: function doValidate() {
                    var _get2;
                    var date = this.date;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (_get2 = _get(_getPrototypeOf(MaskedDate.prototype), "doValidate", this)).call.apply(_get2, [
                        this
                    ].concat(args)) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
                }
            },
            {
                key: "isDateExist",
                value: function isDateExist(str) {
                    return this.format(this.parse(str, this), this).indexOf(str) >= 0;
                }
            },
            {
                key: "date",
                get: function get() {
                    return this.typedValue;
                },
                set: function set(date) {
                    this.typedValue = date;
                }
            },
            {
                key: "typedValue",
                get: function get() {
                    return this.isComplete ? _get(_getPrototypeOf(MaskedDate.prototype), "typedValue", this) : null;
                },
                set: function set(value) {
                    _set(_getPrototypeOf(MaskedDate.prototype), "typedValue", value, this, true);
                }
            },
            {
                key: "maskEquals",
                value: function maskEquals(mask) {
                    return mask === Date || _get(_getPrototypeOf(MaskedDate.prototype), "maskEquals", this).call(this, mask);
                }
            }
        ]);
        return MaskedDate;
    }(MaskedPattern);
    MaskedDate.DEFAULTS = {
        pattern: "d{.}`m{.}`Y",
        format: function format(date) {
            if (!date) return "";
            var day = String(date.getDate()).padStart(2, "0");
            var month = String(date.getMonth() + 1).padStart(2, "0");
            var year = date.getFullYear();
            return [
                day,
                month,
                year
            ].join(".");
        },
        parse: function parse(str) {
            var _str$split = str.split("."), _str$split2 = _slicedToArray(_str$split, 3), day = _str$split2[0], month = _str$split2[1], year = _str$split2[2];
            return new Date(year, month - 1, day);
        }
    };
    MaskedDate.GET_DEFAULT_BLOCKS = function() {
        return {
            d: {
                mask: MaskedRange,
                from: 1,
                to: 31,
                maxLength: 2
            },
            m: {
                mask: MaskedRange,
                from: 1,
                to: 12,
                maxLength: 2
            },
            Y: {
                mask: MaskedRange,
                from: 1900,
                to: 9999
            }
        };
    };
    IMask.MaskedDate = MaskedDate;
    /**
    Generic element API to use with mask
    @interface
  */ var MaskElement = /*#__PURE__*/ function() {
        function MaskElement() {
            _classCallCheck(this, MaskElement);
        }
        _createClass(MaskElement, [
            {
                key: "selectionStart",
                get: /** */ /** */ /** */ /** Safely returns selection start */ function get() {
                    var start;
                    try {
                        start = this._unsafeSelectionStart;
                    } catch (e) {}
                    return start != null ? start : this.value.length;
                }
            },
            {
                key: "selectionEnd",
                get: function get() {
                    var end;
                    try {
                        end = this._unsafeSelectionEnd;
                    } catch (e) {}
                    return end != null ? end : this.value.length;
                }
            },
            {
                key: "select",
                value: function select(start, end) {
                    if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
                    try {
                        this._unsafeSelect(start, end);
                    } catch (e) {}
                }
            },
            {
                key: "_unsafeSelect",
                value: function _unsafeSelect(start, end) {}
            },
            {
                key: "isActive",
                get: function get() {
                    return false;
                }
            },
            {
                key: "bindEvents",
                value: function bindEvents(handlers) {}
            },
            {
                key: "unbindEvents",
                value: function unbindEvents() {}
            }
        ]);
        return MaskElement;
    }();
    IMask.MaskElement = MaskElement;
    /** Bridge between HTMLElement and {@link Masked} */ var HTMLMaskElement = /*#__PURE__*/ function(_MaskElement) {
        _inherits(HTMLMaskElement, _MaskElement);
        var _super = _createSuper(HTMLMaskElement);
        /** Mapping between HTMLElement events and mask internal events */ /** HTMLElement to use mask on */ /**
      @param {HTMLInputElement|HTMLTextAreaElement} input
    */ function HTMLMaskElement(input) {
            var _this;
            _classCallCheck(this, HTMLMaskElement);
            _this = _super.call(this);
            _this.input = input;
            _this._handlers = {};
            return _this;
        }
        /** */ // $FlowFixMe https://github.com/facebook/flow/issues/2839
        _createClass(HTMLMaskElement, [
            {
                key: "rootElement",
                get: function get() {
                    var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
                    return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) === null || _this$input$getRootNo2 === void 0 ? void 0 : _this$input$getRootNo2.call(_this$input)) !== null && _this$input$getRootNo !== void 0 ? _this$input$getRootNo : document;
                }
            },
            {
                key: "isActive",
                get: function get() {
                    //$FlowFixMe
                    return this.input === this.rootElement.activeElement;
                }
            },
            {
                key: "_unsafeSelectionStart",
                get: function get() {
                    return this.input.selectionStart;
                }
            },
            {
                key: "_unsafeSelectionEnd",
                get: function get() {
                    return this.input.selectionEnd;
                }
            },
            {
                key: "_unsafeSelect",
                value: function _unsafeSelect(start, end) {
                    this.input.setSelectionRange(start, end);
                }
            },
            {
                key: "value",
                get: function get() {
                    return this.input.value;
                },
                set: function set(value) {
                    this.input.value = value;
                }
            },
            {
                key: "bindEvents",
                value: function bindEvents(handlers) {
                    var _this2 = this;
                    Object.keys(handlers).forEach(function(event) {
                        return _this2._toggleEventHandler(HTMLMaskElement.EVENTS_MAP[event], handlers[event]);
                    });
                }
            },
            {
                key: "unbindEvents",
                value: function unbindEvents() {
                    var _this3 = this;
                    Object.keys(this._handlers).forEach(function(event) {
                        return _this3._toggleEventHandler(event);
                    });
                }
            },
            {
                key: "_toggleEventHandler",
                value: function _toggleEventHandler(event, handler) {
                    if (this._handlers[event]) {
                        this.input.removeEventListener(event, this._handlers[event]);
                        delete this._handlers[event];
                    }
                    if (handler) {
                        this.input.addEventListener(event, handler);
                        this._handlers[event] = handler;
                    }
                }
            }
        ]);
        return HTMLMaskElement;
    }(MaskElement);
    HTMLMaskElement.EVENTS_MAP = {
        selectionChange: "keydown",
        input: "input",
        drop: "drop",
        click: "click",
        focus: "focus",
        commit: "blur"
    };
    IMask.HTMLMaskElement = HTMLMaskElement;
    var HTMLContenteditableMaskElement = /*#__PURE__*/ function(_HTMLMaskElement) {
        _inherits(HTMLContenteditableMaskElement, _HTMLMaskElement);
        var _super = _createSuper(HTMLContenteditableMaskElement);
        function HTMLContenteditableMaskElement() {
            _classCallCheck(this, HTMLContenteditableMaskElement);
            return _super.apply(this, arguments);
        }
        _createClass(HTMLContenteditableMaskElement, [
            {
                key: "_unsafeSelectionStart",
                get: /**
        Returns HTMLElement selection start
        @override
      */ function get() {
                    var root = this.rootElement;
                    var selection = root.getSelection && root.getSelection();
                    var anchorOffset = selection && selection.anchorOffset;
                    var focusOffset = selection && selection.focusOffset;
                    if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) return anchorOffset;
                    return focusOffset;
                }
            },
            {
                key: "_unsafeSelectionEnd",
                get: function get() {
                    var root = this.rootElement;
                    var selection = root.getSelection && root.getSelection();
                    var anchorOffset = selection && selection.anchorOffset;
                    var focusOffset = selection && selection.focusOffset;
                    if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) return anchorOffset;
                    return focusOffset;
                }
            },
            {
                key: "_unsafeSelect",
                value: function _unsafeSelect(start, end) {
                    if (!this.rootElement.createRange) return;
                    var range = this.rootElement.createRange();
                    range.setStart(this.input.firstChild || this.input, start);
                    range.setEnd(this.input.lastChild || this.input, end);
                    var root = this.rootElement;
                    var selection = root.getSelection && root.getSelection();
                    if (selection) {
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                }
            },
            {
                key: "value",
                get: function get() {
                    // $FlowFixMe
                    return this.input.textContent;
                },
                set: function set(value) {
                    this.input.textContent = value;
                }
            }
        ]);
        return HTMLContenteditableMaskElement;
    }(HTMLMaskElement);
    IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
    var _excluded$1 = [
        "mask"
    ];
    /** Listens to element events and controls changes between element and {@link Masked} */ var InputMask = /*#__PURE__*/ function() {
        /**
      View element
      @readonly
    */ /**
      Internal {@link Masked} model
      @readonly
    */ /**
      @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
      @param {Object} opts
    */ function InputMask(el, opts) {
            _classCallCheck(this, InputMask);
            this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA" ? new HTMLContenteditableMaskElement(el) : new HTMLMaskElement(el);
            this.masked = createMask(opts);
            this._listeners = {};
            this._value = "";
            this._unmaskedValue = "";
            this._saveSelection = this._saveSelection.bind(this);
            this._onInput = this._onInput.bind(this);
            this._onChange = this._onChange.bind(this);
            this._onDrop = this._onDrop.bind(this);
            this._onFocus = this._onFocus.bind(this);
            this._onClick = this._onClick.bind(this);
            this.alignCursor = this.alignCursor.bind(this);
            this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
            this._bindEvents() // refresh
            ;
            this.updateValue();
            this._onChange();
        }
        /** Read or update mask */ _createClass(InputMask, [
            {
                key: "mask",
                get: function get() {
                    return this.masked.mask;
                },
                set: function set(mask) {
                    if (this.maskEquals(mask)) return; // $FlowFixMe No ideas ... after update
                    if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
                        this.masked.updateOptions({
                            mask: mask
                        });
                        return;
                    }
                    var masked = createMask({
                        mask: mask
                    });
                    masked.unmaskedValue = this.masked.unmaskedValue;
                    this.masked = masked;
                }
            },
            {
                key: "maskEquals",
                value: function maskEquals(mask) {
                    var _this$masked;
                    return mask == null || ((_this$masked = this.masked) === null || _this$masked === void 0 ? void 0 : _this$masked.maskEquals(mask));
                }
            },
            {
                key: "value",
                get: function get() {
                    return this._value;
                },
                set: function set(str) {
                    if (this.value === str) return;
                    this.masked.value = str;
                    this.updateControl();
                    this.alignCursor();
                }
            },
            {
                key: "unmaskedValue",
                get: function get() {
                    return this._unmaskedValue;
                },
                set: function set(str) {
                    if (this.unmaskedValue === str) return;
                    this.masked.unmaskedValue = str;
                    this.updateControl();
                    this.alignCursor();
                }
            },
            {
                key: "typedValue",
                get: function get() {
                    return this.masked.typedValue;
                },
                set: function set(val) {
                    if (this.masked.typedValueEquals(val)) return;
                    this.masked.typedValue = val;
                    this.updateControl();
                    this.alignCursor();
                }
            },
            {
                key: "_bindEvents",
                value: function _bindEvents() {
                    this.el.bindEvents({
                        selectionChange: this._saveSelection,
                        input: this._onInput,
                        drop: this._onDrop,
                        click: this._onClick,
                        focus: this._onFocus,
                        commit: this._onChange
                    });
                }
            },
            {
                key: "_unbindEvents",
                value: function _unbindEvents() {
                    if (this.el) this.el.unbindEvents();
                }
            },
            {
                key: "_fireEvent",
                value: function _fireEvent(ev) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    var listeners = this._listeners[ev];
                    if (!listeners) return;
                    listeners.forEach(function(l) {
                        return l.apply(void 0, args);
                    });
                }
            },
            {
                key: "selectionStart",
                get: function get() {
                    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
                }
            },
            {
                key: "cursorPos",
                get: function get() {
                    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
                },
                set: function set(pos) {
                    if (!this.el || !this.el.isActive) return;
                    this.el.select(pos, pos);
                    this._saveSelection();
                }
            },
            {
                key: "_saveSelection",
                value: function /* ev */ _saveSelection() {
                    if (this.value !== this.el.value) console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.") // eslint-disable-line no-console
                    ;
                    this._selection = {
                        start: this.selectionStart,
                        end: this.cursorPos
                    };
                }
            },
            {
                key: "updateValue",
                value: function updateValue() {
                    this.masked.value = this.el.value;
                    this._value = this.masked.value;
                }
            },
            {
                key: "updateControl",
                value: function updateControl() {
                    var newUnmaskedValue = this.masked.unmaskedValue;
                    var newValue = this.masked.value;
                    var isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
                    this._unmaskedValue = newUnmaskedValue;
                    this._value = newValue;
                    if (this.el.value !== newValue) this.el.value = newValue;
                    if (isChanged) this._fireChangeEvents();
                }
            },
            {
                key: "updateOptions",
                value: function updateOptions(opts) {
                    var mask = opts.mask, restOpts = _objectWithoutProperties(opts, _excluded$1);
                    var updateMask = !this.maskEquals(mask);
                    var updateOpts = !objectIncludes(this.masked, restOpts);
                    if (updateMask) this.mask = mask;
                    if (updateOpts) this.masked.updateOptions(restOpts);
                    if (updateMask || updateOpts) this.updateControl();
                }
            },
            {
                key: "updateCursor",
                value: function updateCursor(cursorPos) {
                    if (cursorPos == null) return;
                    this.cursorPos = cursorPos // also queue change cursor for mobile browsers
                    ;
                    this._delayUpdateCursor(cursorPos);
                }
            },
            {
                key: "_delayUpdateCursor",
                value: function _delayUpdateCursor(cursorPos) {
                    var _this = this;
                    this._abortUpdateCursor();
                    this._changingCursorPos = cursorPos;
                    this._cursorChanging = setTimeout(function() {
                        if (!_this.el) return; // if was destroyed
                        _this.cursorPos = _this._changingCursorPos;
                        _this._abortUpdateCursor();
                    }, 10);
                }
            },
            {
                key: "_fireChangeEvents",
                value: function _fireChangeEvents() {
                    this._fireEvent("accept", this._inputEvent);
                    if (this.masked.isComplete) this._fireEvent("complete", this._inputEvent);
                }
            },
            {
                key: "_abortUpdateCursor",
                value: function _abortUpdateCursor() {
                    if (this._cursorChanging) {
                        clearTimeout(this._cursorChanging);
                        delete this._cursorChanging;
                    }
                }
            },
            {
                key: "alignCursor",
                value: function alignCursor() {
                    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
                }
            },
            {
                key: "alignCursorFriendly",
                value: function alignCursorFriendly() {
                    if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
                    this.alignCursor();
                }
            },
            {
                key: "on",
                value: function on(ev, handler) {
                    if (!this._listeners[ev]) this._listeners[ev] = [];
                    this._listeners[ev].push(handler);
                    return this;
                }
            },
            {
                key: "off",
                value: function off(ev, handler) {
                    if (!this._listeners[ev]) return this;
                    if (!handler) {
                        delete this._listeners[ev];
                        return this;
                    }
                    var hIndex = this._listeners[ev].indexOf(handler);
                    if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
                    return this;
                }
            },
            {
                key: "_onInput",
                value: function _onInput(e) {
                    this._inputEvent = e;
                    this._abortUpdateCursor() // fix strange IE behavior
                    ;
                    if (!this._selection) return this.updateValue();
                    var details = new ActionDetails(this.el.value, this.cursorPos, this.value, this._selection);
                    var oldRawValue = this.masked.rawInputValue;
                    var offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
                        input: true,
                        raw: true
                    }).offset // force align in remove direction only if no input chars were removed
                    ;
                    // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
                    var removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
                    var cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
                    if (removeDirection !== DIRECTION.NONE) cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
                    this.updateControl();
                    this.updateCursor(cursorPos);
                    delete this._inputEvent;
                }
            },
            {
                key: "_onChange",
                value: function _onChange() {
                    if (this.value !== this.el.value) this.updateValue();
                    this.masked.doCommit();
                    this.updateControl();
                    this._saveSelection();
                }
            },
            {
                key: "_onDrop",
                value: function _onDrop(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            },
            {
                key: "_onFocus",
                value: function _onFocus(ev) {
                    this.alignCursorFriendly();
                }
            },
            {
                key: "_onClick",
                value: function _onClick(ev) {
                    this.alignCursorFriendly();
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    this._unbindEvents() // $FlowFixMe why not do so?
                    ;
                    this._listeners.length = 0 // $FlowFixMe
                    ;
                    delete this.el;
                }
            }
        ]);
        return InputMask;
    }();
    IMask.InputMask = InputMask;
    /** Pattern which validates enum values */ var MaskedEnum = /*#__PURE__*/ function(_MaskedPattern) {
        _inherits(MaskedEnum, _MaskedPattern);
        var _super = _createSuper(MaskedEnum);
        function MaskedEnum() {
            _classCallCheck(this, MaskedEnum);
            return _super.apply(this, arguments);
        }
        _createClass(MaskedEnum, [
            {
                key: "_update",
                value: /**
        @override
        @param {Object} opts
      */ function _update(opts) {
                    // TODO type
                    if (opts.enum) opts.mask = "*".repeat(opts.enum[0].length);
                    _get(_getPrototypeOf(MaskedEnum.prototype), "_update", this).call(this, opts);
                }
            },
            {
                key: "doValidate",
                value: function doValidate() {
                    var _this = this, _get2;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return this.enum.some(function(e) {
                        return e.indexOf(_this.unmaskedValue) >= 0;
                    }) && (_get2 = _get(_getPrototypeOf(MaskedEnum.prototype), "doValidate", this)).call.apply(_get2, [
                        this
                    ].concat(args));
                }
            }
        ]);
        return MaskedEnum;
    }(MaskedPattern);
    IMask.MaskedEnum = MaskedEnum;
    /**
    Number mask
    @param {Object} opts
    @param {string} opts.radix - Single char
    @param {string} opts.thousandsSeparator - Single char
    @param {Array<string>} opts.mapToRadix - Array of single chars
    @param {number} opts.min
    @param {number} opts.max
    @param {number} opts.scale - Digits after point
    @param {boolean} opts.signed - Allow negative
    @param {boolean} opts.normalizeZeros - Flag to remove leading and trailing zeros in the end of editing
    @param {boolean} opts.padFractionalZeros - Flag to pad trailing zeros after point in the end of editing
  */ var MaskedNumber = /*#__PURE__*/ function(_Masked) {
        _inherits(MaskedNumber, _Masked);
        var _super = _createSuper(MaskedNumber);
        /** Single char */ /** Single char */ /** Array of single chars */ /** */ /** */ /** Digits after point */ /** */ /** Flag to remove leading and trailing zeros in the end of editing */ /** Flag to pad trailing zeros after point in the end of editing */ function MaskedNumber(opts) {
            _classCallCheck(this, MaskedNumber);
            return _super.call(this, Object.assign({}, MaskedNumber.DEFAULTS, opts));
        }
        /**
      @override
    */ _createClass(MaskedNumber, [
            {
                key: "_update",
                value: function _update(opts) {
                    _get(_getPrototypeOf(MaskedNumber.prototype), "_update", this).call(this, opts);
                    this._updateRegExps();
                }
            },
            {
                key: "_updateRegExps",
                value: function _updateRegExps() {
                    // use different regexp to process user input (more strict, input suffix) and tail shifting
                    var start = "^" + (this.allowNegative ? "[+|\\-]?" : "");
                    var midInput = "(0|([1-9]+\\d*))?";
                    var mid = "\\d*";
                    var end = (this.scale ? "(" + escapeRegExp(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
                    this._numberRegExpInput = new RegExp(start + midInput + end);
                    this._numberRegExp = new RegExp(start + mid + end);
                    this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(escapeRegExp).join("") + "]", "g");
                    this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), "g");
                }
            },
            {
                key: "_removeThousandsSeparators",
                value: function _removeThousandsSeparators(value) {
                    return value.replace(this._thousandsSeparatorRegExp, "");
                }
            },
            {
                key: "_insertThousandsSeparators",
                value: function _insertThousandsSeparators(value) {
                    // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
                    var parts = value.split(this.radix);
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
                    return parts.join(this.radix);
                }
            },
            {
                key: "doPrepare",
                value: function doPrepare(ch) {
                    var _get2;
                    ch = ch.replace(this._mapToRadixRegExp, this.radix);
                    var noSepCh = this._removeThousandsSeparators(ch);
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    var _normalizePrepare = normalizePrepare((_get2 = _get(_getPrototypeOf(MaskedNumber.prototype), "doPrepare", this)).call.apply(_get2, [
                        this,
                        noSepCh
                    ].concat(args))), _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2), prepCh = _normalizePrepare2[0], details = _normalizePrepare2[1];
                    if (ch && !noSepCh) details.skip = true;
                    return [
                        prepCh,
                        details
                    ];
                }
            },
            {
                key: "_separatorsCount",
                value: function _separatorsCount(to) {
                    var extendOnSeparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var count = 0;
                    for(var pos = 0; pos < to; ++pos)if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
                        ++count;
                        if (extendOnSeparators) to += this.thousandsSeparator.length;
                    }
                    return count;
                }
            },
            {
                key: "_separatorsCountFromSlice",
                value: function _separatorsCountFromSlice() {
                    var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._value;
                    return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
                }
            },
            {
                key: "extractInput",
                value: function extractInput() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    var flags = arguments.length > 2 ? arguments[2] : undefined;
                    var _this$_adjustRangeWit = this._adjustRangeWithSeparators(fromPos, toPos);
                    var _this$_adjustRangeWit2 = _slicedToArray(_this$_adjustRangeWit, 2);
                    fromPos = _this$_adjustRangeWit2[0];
                    toPos = _this$_adjustRangeWit2[1];
                    return this._removeThousandsSeparators(_get(_getPrototypeOf(MaskedNumber.prototype), "extractInput", this).call(this, fromPos, toPos, flags));
                }
            },
            {
                key: "_appendCharRaw",
                value: function _appendCharRaw(ch) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (!this.thousandsSeparator) return _get(_getPrototypeOf(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);
                    var prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
                    var prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
                    this._value = this._removeThousandsSeparators(this.value);
                    var appendDetails = _get(_getPrototypeOf(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);
                    this._value = this._insertThousandsSeparators(this._value);
                    var beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
                    var beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
                    appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
                    appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
                    return appendDetails;
                }
            },
            {
                key: "_findSeparatorAround",
                value: function _findSeparatorAround(pos) {
                    if (this.thousandsSeparator) {
                        var searchFrom = pos - this.thousandsSeparator.length + 1;
                        var separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
                        if (separatorPos <= pos) return separatorPos;
                    }
                    return -1;
                }
            },
            {
                key: "_adjustRangeWithSeparators",
                value: function _adjustRangeWithSeparators(from, to) {
                    var separatorAroundFromPos = this._findSeparatorAround(from);
                    if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
                    var separatorAroundToPos = this._findSeparatorAround(to);
                    if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
                    return [
                        from,
                        to
                    ];
                }
            },
            {
                key: "remove",
                value: function remove() {
                    var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                    var _this$_adjustRangeWit3 = this._adjustRangeWithSeparators(fromPos, toPos);
                    var _this$_adjustRangeWit4 = _slicedToArray(_this$_adjustRangeWit3, 2);
                    fromPos = _this$_adjustRangeWit4[0];
                    toPos = _this$_adjustRangeWit4[1];
                    var valueBeforePos = this.value.slice(0, fromPos);
                    var valueAfterPos = this.value.slice(toPos);
                    var prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
                    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
                    var beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
                    return new ChangeDetails({
                        tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
                    });
                }
            },
            {
                key: "nearestInputPos",
                value: function nearestInputPos(cursorPos, direction) {
                    if (!this.thousandsSeparator) return cursorPos;
                    switch(direction){
                        case DIRECTION.NONE:
                        case DIRECTION.LEFT:
                        case DIRECTION.FORCE_LEFT:
                            var separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
                            if (separatorAtLeftPos >= 0) {
                                var separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
                                if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) return separatorAtLeftPos;
                            }
                            break;
                        case DIRECTION.RIGHT:
                        case DIRECTION.FORCE_RIGHT:
                            var separatorAtRightPos = this._findSeparatorAround(cursorPos);
                            if (separatorAtRightPos >= 0) return separatorAtRightPos + this.thousandsSeparator.length;
                    }
                    return cursorPos;
                }
            },
            {
                key: "doValidate",
                value: function doValidate(flags) {
                    var regexp = flags.input ? this._numberRegExpInput : this._numberRegExp // validate as string
                    ;
                    var valid = regexp.test(this._removeThousandsSeparators(this.value));
                    if (valid) {
                        // validate as number
                        var number = this.number;
                        valid = valid && !isNaN(number) && // check min bound for negative values
                        (this.min == null || this.min >= 0 || this.min <= this.number) && // check max bound for positive values
                        (this.max == null || this.max <= 0 || this.number <= this.max);
                    }
                    return valid && _get(_getPrototypeOf(MaskedNumber.prototype), "doValidate", this).call(this, flags);
                }
            },
            {
                key: "doCommit",
                value: function doCommit() {
                    if (this.value) {
                        var number = this.number;
                        var validnum = number // check bounds
                        ;
                        if (this.min != null) validnum = Math.max(validnum, this.min);
                        if (this.max != null) validnum = Math.min(validnum, this.max);
                        if (validnum !== number) this.unmaskedValue = String(validnum);
                        var formatted = this.value;
                        if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
                        if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
                        this._value = formatted;
                    }
                    _get(_getPrototypeOf(MaskedNumber.prototype), "doCommit", this).call(this);
                }
            },
            {
                key: "_normalizeZeros",
                value: function _normalizeZeros(value) {
                    var parts = this._removeThousandsSeparators(value).split(this.radix) // remove leading zeros
                    ;
                    parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, function(match, sign, zeros, num) {
                        return sign + num;
                    }) // add leading zero
                    ;
                    if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + "0";
                    if (parts.length > 1) {
                        parts[1] = parts[1].replace(/0*$/, "") // remove trailing zeros
                        ;
                        if (!parts[1].length) parts.length = 1 // remove fractional
                        ;
                    }
                    return this._insertThousandsSeparators(parts.join(this.radix));
                }
            },
            {
                key: "_padFractionalZeros",
                value: function _padFractionalZeros(value) {
                    if (!value) return value;
                    var parts = value.split(this.radix);
                    if (parts.length < 2) parts.push("");
                    parts[1] = parts[1].padEnd(this.scale, "0");
                    return parts.join(this.radix);
                }
            },
            {
                key: "unmaskedValue",
                get: function get() {
                    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, ".");
                },
                set: function set(unmaskedValue) {
                    _set(_getPrototypeOf(MaskedNumber.prototype), "unmaskedValue", unmaskedValue.replace(".", this.radix), this, true);
                }
            },
            {
                key: "typedValue",
                get: function get() {
                    return Number(this.unmaskedValue);
                },
                set: function set(n) {
                    _set(_getPrototypeOf(MaskedNumber.prototype), "unmaskedValue", String(n), this, true);
                }
            },
            {
                key: "number",
                get: function get() {
                    return this.typedValue;
                },
                set: function set(number) {
                    this.typedValue = number;
                }
            },
            {
                key: "allowNegative",
                get: function get() {
                    return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
                }
            },
            {
                key: "typedValueEquals",
                value: function typedValueEquals(value) {
                    // handle  0 -> '' case (typed = 0 even if value = '')
                    // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
                    return (_get(_getPrototypeOf(MaskedNumber.prototype), "typedValueEquals", this).call(this, value) || MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === "");
                }
            }
        ]);
        return MaskedNumber;
    }(Masked);
    MaskedNumber.DEFAULTS = {
        radix: ",",
        thousandsSeparator: "",
        mapToRadix: [
            "."
        ],
        scale: 2,
        signed: false,
        normalizeZeros: true,
        padFractionalZeros: false
    };
    MaskedNumber.EMPTY_VALUES = [].concat(_toConsumableArray(Masked.EMPTY_VALUES), [
        0
    ]);
    IMask.MaskedNumber = MaskedNumber;
    /** Masking by custom Function */ var MaskedFunction = /*#__PURE__*/ function(_Masked) {
        _inherits(MaskedFunction, _Masked);
        var _super = _createSuper(MaskedFunction);
        function MaskedFunction() {
            _classCallCheck(this, MaskedFunction);
            return _super.apply(this, arguments);
        }
        _createClass(MaskedFunction, [
            {
                key: "_update",
                value: /**
        @override
        @param {Object} opts
      */ function _update(opts) {
                    if (opts.mask) opts.validate = opts.mask;
                    _get(_getPrototypeOf(MaskedFunction.prototype), "_update", this).call(this, opts);
                }
            }
        ]);
        return MaskedFunction;
    }(Masked);
    IMask.MaskedFunction = MaskedFunction;
    var _excluded = [
        "compiledMasks",
        "currentMaskRef",
        "currentMask"
    ];
    /** Dynamic mask for choosing apropriate mask in run-time */ var MaskedDynamic = /*#__PURE__*/ function(_Masked) {
        _inherits(MaskedDynamic, _Masked);
        var _super = _createSuper(MaskedDynamic);
        /** Currently chosen mask */ /** Compliled {@link Masked} options */ /** Chooses {@link Masked} depending on input value */ /**
      @param {Object} opts
    */ function MaskedDynamic(opts) {
            var _this;
            _classCallCheck(this, MaskedDynamic);
            _this = _super.call(this, Object.assign({}, MaskedDynamic.DEFAULTS, opts));
            _this.currentMask = null;
            return _this;
        }
        /**
      @override
    */ _createClass(MaskedDynamic, [
            {
                key: "_update",
                value: function _update(opts) {
                    _get(_getPrototypeOf(MaskedDynamic.prototype), "_update", this).call(this, opts);
                    if ("mask" in opts) // mask could be totally dynamic with only `dispatch` option
                    this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(function(m) {
                        return createMask(m);
                    }) : [];
                }
            },
            {
                key: "_appendCharRaw",
                value: function _appendCharRaw(ch) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var details = this._applyDispatch(ch, flags);
                    if (this.currentMask) details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
                    return details;
                }
            },
            {
                key: "_applyDispatch",
                value: function _applyDispatch() {
                    var appended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
                    var inputValue = this.rawInputValue;
                    var insertValue = flags.tail && flags._beforeTailState != null // $FlowFixMe - tired to fight with type system
                     ? flags._beforeTailState._rawInputValue : inputValue;
                    var tailValue = inputValue.slice(insertValue.length);
                    var prevMask = this.currentMask;
                    var details = new ChangeDetails();
                    var prevMaskState = prevMask === null || prevMask === void 0 ? void 0 : prevMask.state // clone flags to prevent overwriting `_beforeTailState`
                    ;
                    this.currentMask = this.doDispatch(appended, Object.assign({}, flags)) // restore state after dispatch
                    ;
                    if (this.currentMask) {
                        if (this.currentMask !== prevMask) {
                            // if mask changed reapply input
                            this.currentMask.reset();
                            if (insertValue) {
                                // $FlowFixMe - it's ok, we don't change current mask above
                                var d = this.currentMask.append(insertValue, {
                                    raw: true
                                });
                                details.tailShift = d.inserted.length - prevValueBeforeTail.length;
                            }
                            if (tailValue) // $FlowFixMe - it's ok, we don't change current mask above
                            details.tailShift += this.currentMask.append(tailValue, {
                                raw: true,
                                tail: true
                            }).tailShift;
                        } else // Dispatch can do something bad with state, so
                        // restore prev mask state
                        this.currentMask.state = prevMaskState;
                    }
                    return details;
                }
            },
            {
                key: "_appendPlaceholder",
                value: function _appendPlaceholder() {
                    var details = this._applyDispatch.apply(this, arguments);
                    if (this.currentMask) details.aggregate(this.currentMask._appendPlaceholder());
                    return details;
                }
            },
            {
                key: "_appendEager",
                value: function _appendEager() {
                    var details = this._applyDispatch.apply(this, arguments);
                    if (this.currentMask) details.aggregate(this.currentMask._appendEager());
                    return details;
                }
            },
            {
                key: "currentMaskFlags",
                value: function currentMaskFlags(flags) {
                    var _flags$_beforeTailSta, _flags$_beforeTailSta2;
                    return Object.assign({}, flags, {
                        _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
                    });
                }
            },
            {
                key: "doDispatch",
                value: function doDispatch(appended) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    return this.dispatch(appended, this, flags);
                }
            },
            {
                key: "doValidate",
                value: function doValidate(flags) {
                    return _get(_getPrototypeOf(MaskedDynamic.prototype), "doValidate", this).call(this, flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
                }
            },
            {
                key: "doPrepare",
                value: function doPrepare(str) {
                    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var _normalizePrepare = normalizePrepare(_get(_getPrototypeOf(MaskedDynamic.prototype), "doPrepare", this).call(this, str, flags)), _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2), s = _normalizePrepare2[0], details = _normalizePrepare2[1];
                    if (this.currentMask) {
                        var currentDetails;
                        var _normalizePrepare3 = normalizePrepare(_get(_getPrototypeOf(MaskedDynamic.prototype), "doPrepare", this).call(this, s, this.currentMaskFlags(flags)));
                        var _normalizePrepare4 = _slicedToArray(_normalizePrepare3, 2);
                        s = _normalizePrepare4[0];
                        currentDetails = _normalizePrepare4[1];
                        details = details.aggregate(currentDetails);
                    }
                    return [
                        s,
                        details
                    ];
                }
            },
            {
                key: "reset",
                value: function reset() {
                    var _this$currentMask;
                    (_this$currentMask = this.currentMask) === null || _this$currentMask === void 0 || _this$currentMask.reset();
                    this.compiledMasks.forEach(function(m) {
                        return m.reset();
                    });
                }
            },
            {
                key: "value",
                get: function get() {
                    return this.currentMask ? this.currentMask.value : "";
                },
                set: function set(value) {
                    _set(_getPrototypeOf(MaskedDynamic.prototype), "value", value, this, true);
                }
            },
            {
                key: "unmaskedValue",
                get: function get() {
                    return this.currentMask ? this.currentMask.unmaskedValue : "";
                },
                set: function set(unmaskedValue) {
                    _set(_getPrototypeOf(MaskedDynamic.prototype), "unmaskedValue", unmaskedValue, this, true);
                }
            },
            {
                key: "typedValue",
                get: function get() {
                    return this.currentMask ? this.currentMask.typedValue : "";
                },
                set: function set(value) {
                    var unmaskedValue = String(value) // double check it
                    ;
                    if (this.currentMask) {
                        this.currentMask.typedValue = value;
                        unmaskedValue = this.currentMask.unmaskedValue;
                    }
                    this.unmaskedValue = unmaskedValue;
                }
            },
            {
                key: "isComplete",
                get: function get() {
                    var _this$currentMask2;
                    return Boolean((_this$currentMask2 = this.currentMask) === null || _this$currentMask2 === void 0 ? void 0 : _this$currentMask2.isComplete);
                }
            },
            {
                key: "isFilled",
                get: function get() {
                    var _this$currentMask3;
                    return Boolean((_this$currentMask3 = this.currentMask) === null || _this$currentMask3 === void 0 ? void 0 : _this$currentMask3.isFilled);
                }
            },
            {
                key: "remove",
                value: function remove() {
                    var details = new ChangeDetails();
                    if (this.currentMask) {
                        var _this$currentMask4;
                        details.aggregate((_this$currentMask4 = this.currentMask).remove.apply(_this$currentMask4, arguments)) // update with dispatch
                        .aggregate(this._applyDispatch());
                    }
                    return details;
                }
            },
            {
                key: "state",
                get: function get() {
                    var _this$currentMask5;
                    return Object.assign({}, _get(_getPrototypeOf(MaskedDynamic.prototype), "state", this), {
                        _rawInputValue: this.rawInputValue,
                        compiledMasks: this.compiledMasks.map(function(m) {
                            return m.state;
                        }),
                        currentMaskRef: this.currentMask,
                        currentMask: (_this$currentMask5 = this.currentMask) === null || _this$currentMask5 === void 0 ? void 0 : _this$currentMask5.state
                    });
                },
                set: function set(state) {
                    var compiledMasks = state.compiledMasks, currentMaskRef = state.currentMaskRef, currentMask = state.currentMask, maskedState = _objectWithoutProperties(state, _excluded);
                    this.compiledMasks.forEach(function(m, mi) {
                        return m.state = compiledMasks[mi];
                    });
                    if (currentMaskRef != null) {
                        this.currentMask = currentMaskRef;
                        this.currentMask.state = currentMask;
                    }
                    _set(_getPrototypeOf(MaskedDynamic.prototype), "state", maskedState, this, true);
                }
            },
            {
                key: "extractInput",
                value: function extractInput() {
                    var _this$currentMask6;
                    return this.currentMask ? (_this$currentMask6 = this.currentMask).extractInput.apply(_this$currentMask6, arguments) : "";
                }
            },
            {
                key: "extractTail",
                value: function extractTail() {
                    var _this$currentMask7, _get2;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return this.currentMask ? (_this$currentMask7 = this.currentMask).extractTail.apply(_this$currentMask7, args) : (_get2 = _get(_getPrototypeOf(MaskedDynamic.prototype), "extractTail", this)).call.apply(_get2, [
                        this
                    ].concat(args));
                }
            },
            {
                key: "doCommit",
                value: function doCommit() {
                    if (this.currentMask) this.currentMask.doCommit();
                    _get(_getPrototypeOf(MaskedDynamic.prototype), "doCommit", this).call(this);
                }
            },
            {
                key: "nearestInputPos",
                value: function nearestInputPos() {
                    var _this$currentMask8, _get3;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    return this.currentMask ? (_this$currentMask8 = this.currentMask).nearestInputPos.apply(_this$currentMask8, args) : (_get3 = _get(_getPrototypeOf(MaskedDynamic.prototype), "nearestInputPos", this)).call.apply(_get3, [
                        this
                    ].concat(args));
                }
            },
            {
                key: "overwrite",
                get: function get() {
                    return this.currentMask ? this.currentMask.overwrite : _get(_getPrototypeOf(MaskedDynamic.prototype), "overwrite", this);
                },
                set: function set(overwrite) {
                    console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
                }
            },
            {
                key: "eager",
                get: function get() {
                    return this.currentMask ? this.currentMask.eager : _get(_getPrototypeOf(MaskedDynamic.prototype), "eager", this);
                },
                set: function set(eager) {
                    console.warn('"eager" option is not available in dynamic mask, use this option in siblings');
                }
            },
            {
                key: "maskEquals",
                value: function maskEquals(mask) {
                    return Array.isArray(mask) && this.compiledMasks.every(function(m, mi) {
                        var _mask$mi;
                        return m.maskEquals((_mask$mi = mask[mi]) === null || _mask$mi === void 0 ? void 0 : _mask$mi.mask);
                    });
                }
            },
            {
                key: "typedValueEquals",
                value: function typedValueEquals(value) {
                    var _this$currentMask9;
                    return Boolean((_this$currentMask9 = this.currentMask) === null || _this$currentMask9 === void 0 ? void 0 : _this$currentMask9.typedValueEquals(value));
                }
            }
        ]);
        return MaskedDynamic;
    }(Masked);
    MaskedDynamic.DEFAULTS = {
        dispatch: function dispatch(appended, masked, flags) {
            if (!masked.compiledMasks.length) return;
            var inputValue = masked.rawInputValue // simulate input
            ;
            var inputs = masked.compiledMasks.map(function(m, index) {
                m.reset();
                m.append(inputValue, {
                    raw: true
                });
                m.append(appended, masked.currentMaskFlags(flags));
                var weight = m.rawInputValue.length;
                return {
                    weight: weight,
                    index: index
                };
            }) // pop masks with longer values first
            ;
            inputs.sort(function(i1, i2) {
                return i2.weight - i1.weight;
            });
            return masked.compiledMasks[inputs[0].index];
        }
    };
    IMask.MaskedDynamic = MaskedDynamic;
    /** Mask pipe source and destination types */ var PIPE_TYPE = {
        MASKED: "value",
        UNMASKED: "unmaskedValue",
        TYPED: "typedValue"
    };
    /** Creates new pipe function depending on mask type, source and destination options */ function createPipe(mask) {
        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PIPE_TYPE.MASKED;
        var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PIPE_TYPE.MASKED;
        var masked = createMask(mask);
        return function(value) {
            return masked.runIsolated(function(m) {
                m[from] = value;
                return m[to];
            });
        };
    }
    /** Pipes value through mask depending on mask type, source and destination options */ function pipe(value) {
        for(var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)pipeArgs[_key - 1] = arguments[_key];
        return createPipe.apply(void 0, pipeArgs)(value);
    }
    IMask.PIPE_TYPE = PIPE_TYPE;
    IMask.createPipe = createPipe;
    IMask.pipe = pipe;
    try {
        globalThis.IMask = IMask;
    } catch (e) {}
    exports1.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
    exports1.HTMLMaskElement = HTMLMaskElement;
    exports1.InputMask = InputMask;
    exports1.MaskElement = MaskElement;
    exports1.Masked = Masked;
    exports1.MaskedDate = MaskedDate;
    exports1.MaskedDynamic = MaskedDynamic;
    exports1.MaskedEnum = MaskedEnum;
    exports1.MaskedFunction = MaskedFunction;
    exports1.MaskedNumber = MaskedNumber;
    exports1.MaskedPattern = MaskedPattern;
    exports1.MaskedRange = MaskedRange;
    exports1.MaskedRegExp = MaskedRegExp;
    exports1.PIPE_TYPE = PIPE_TYPE;
    exports1.createMask = createMask;
    exports1.createPipe = createPipe;
    exports1["default"] = IMask;
    exports1.pipe = pipe;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
}) //# sourceMappingURL=imask.js.map
;


function $0126659c94792a9b$export$c27c630f90de7078(mask, value) {
    const masked = (0, (/*@__PURE__*/$parcel$interopDefault($506efabaf57d4bc1$exports))).createMask({
        mask: mask
    });
    return masked.resolve(String(value));
}
function $0126659c94792a9b$export$4de63bc21318e316(value) {
    return value.replace(/\D/g, "");
}


const $2e33081926f1629c$export$923ea8233b386e99 = "https://api.chat.needtech.cc/graphql";
const $2e33081926f1629c$export$79620fa9d5a51578 = "wss://api.chat.needtech.cc/graphql";
const $2e33081926f1629c$export$402385aaae50990c = "polvo";
const $2e33081926f1629c$export$984d1cabff779405 = "@publicChat@chatId";
const $2e33081926f1629c$export$348cb4c643121c33 = "@publicChat@chatMessages";


function $22897638eb19270b$export$9a56bf961247f454() {
    const chat = localStorage.getItem((0, $2e33081926f1629c$export$348cb4c643121c33));
    if (!chat) return null;
    return JSON.parse(chat);
}
function $22897638eb19270b$export$361251948aac9392() {
    localStorage.removeItem((0, $2e33081926f1629c$export$348cb4c643121c33));
}
function $22897638eb19270b$export$5952f64721fa339b(value) {
    localStorage.setItem((0, $2e33081926f1629c$export$348cb4c643121c33), JSON.stringify(value));
}
function $22897638eb19270b$export$614e007823d2557b(newMessage) {
    let currentChatMessages = $22897638eb19270b$export$9a56bf961247f454();
    if (!currentChatMessages) {
        currentChatMessages = [
            newMessage
        ];
        $22897638eb19270b$export$5952f64721fa339b(currentChatMessages);
        return;
    }
    currentChatMessages.push(newMessage);
    $22897638eb19270b$export$5952f64721fa339b(currentChatMessages);
    return currentChatMessages;
}
function $22897638eb19270b$export$30a3ed6c591b3762() {
    return localStorage.getItem((0, $2e33081926f1629c$export$984d1cabff779405));
}
function $22897638eb19270b$export$9d3459bb89d8aa3b() {
    localStorage.removeItem((0, $2e33081926f1629c$export$984d1cabff779405));
}
function $22897638eb19270b$export$a6349eb46da4948a(value) {
    localStorage.setItem((0, $2e33081926f1629c$export$984d1cabff779405), value);
}



const $591003e260097fb2$var$headers = {
    "Company-Slug": (0, $2e33081926f1629c$export$402385aaae50990c),
    "Content-Type": "application/json"
};
async function $591003e260097fb2$export$b06728f6e7f99a12(query, variables = {}) {
    try {
        const response = await fetch((0, $2e33081926f1629c$export$923ea8233b386e99), {
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            cache: "no-cache",
            credentials: "same-origin",
            headers: $591003e260097fb2$var$headers,
            method: "POST",
            mode: "cors",
            redirect: "follow",
            referrerPolicy: "no-referrer"
        });
        return response.json();
    } catch (error) {
        console.error(error);
    }
}
const $591003e260097fb2$var$headersSubscription = {
    ...$591003e260097fb2$var$headers,
    isPublic: true
};
function $591003e260097fb2$export$77d98e234285cf80() {
    const socket = new WebSocket((0, $2e33081926f1629c$export$79620fa9d5a51578), "graphql-ws");
    socket.onopen = ()=>{
        const connectionInit = JSON.stringify({
            payload: {
                ...$591003e260097fb2$var$headersSubscription
            },
            type: "connection_init"
        });
        socket.send(connectionInit);
    };
    return socket;
}


const $7f4c0c598b81a0c6$export$86b5979e3a4ec943 = ({ cpf: cpf , departmentId: departmentId , name: name  })=>`
  mutation {
    startAPIChat(
      client: {
        identification: "${cpf}"
        name: "${name}"
      }
      departmentId: "${departmentId}"
    ) {
      chatId
      defaultMessage {
        id
        createdAt
        subject
        text
      }
    }
  }
`;


const $0760601060bec790$export$23a1f3ac1c2f685 = "#A4BCD6BF";
const $0760601060bec790$export$ecb4d01658531d2e = "#004d34";
const $0760601060bec790$export$5e849c266edab07c = {
    dark: "#A4BCD6",
    light: "#D8E4F1"
};
const $0760601060bec790$export$4a7bcf574627a18d = "#FFFFFF";
const $0760601060bec790$export$29cab4719f80d755 = "#FFFFFF";
const $0760601060bec790$export$bb40f9313785d264 = "#FFFFFF";
const $0760601060bec790$export$450b76c0a51df89 = "#FFFFFF";
const $0760601060bec790$export$c8df4bc4e3ef7f8e = "#FFFFFF";
const $0760601060bec790$export$926e70b78fead0fe = "#283443";
const $0760601060bec790$export$ae2e01bf56a52a6 = "#FFFFFF";



const $bda9123ef1b17172$export$11d476d26c515b92 = `
  #public-chat {
    align-items: center;
    background-color: ${(0, $0760601060bec790$export$4a7bcf574627a18d)};
    border-radius: 50%;
    bottom: 10px;
    box-shadow: 0px 0px 5px 0px ${(0, $0760601060bec790$export$23a1f3ac1c2f685)};
    cursor: pointer;
    display: flex;
    height: 70px;
    justify-content: center;
    padding: 0;
    position: fixed;
    right: 10px;
    width: 70px;
    z-index: 99999;
  }
`;
const $bda9123ef1b17172$export$f7a371685c5796cd = `
  #public-chat {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: center;

    bottom: 10px;
    position: fixed;
    right: 10px;
    z-index: 99999;

    background-color: ${(0, $0760601060bec790$export$29cab4719f80d755)};
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px ${(0, $0760601060bec790$export$23a1f3ac1c2f685)};
    cursor: default;

    height: 500px;
    padding: 10px;
    width: 350px;
  }

  #public-chat .chat {
    background-color: ${(0, $0760601060bec790$export$5e849c266edab07c).light};
    border-radius: 5px;

    display: grid;
    grid-template-rows: 1fr 50px;

    height: calc(100% - 10px);
    width: 100%;
  }

  #public-chat .chat #messages {
    display: flex;
    flex-direction: column-reverse;
    gap: 5px;
    padding: 10px;

    height: 100%;
    overflow-y: auto;
  }

  #public-chat .chat #messages .message {
    display: flex;
    width: 100%;
  }

  #public-chat .chat #messages .message.admin,
  #public-chat .chat #messages .message.bot {
    flex-direction: row;
  }

  #public-chat .chat #messages .message.client {
    flex-direction: row-reverse;
  }

  #public-chat .chat #messages .message > div {
    background-color: ${(0, $0760601060bec790$export$5e849c266edab07c).dark};
    border-radius: 10px;
    max-width: 65%;
    padding: 10px;
  }

  #public-chat .chat #messages .message > div p {
    color: ${(0, $0760601060bec790$export$ae2e01bf56a52a6)};
  }

  #public-chat .chat form {
    background-color: ${(0, $0760601060bec790$export$5e849c266edab07c).dark};
    border-radius: 0 0 5px 5px;
    display: grid;
    grid-template-columns: 1fr 40px;
    gap: 5px;
    padding: 5px;
  }

  #public-chat .chat form input {
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
  }

  #public-chat .chat form button {
    background-color: transparent;
    border: none;
    width: 40px;
  }
`;
const $bda9123ef1b17172$export$55e3a752d0357364 = `
  #public-chat {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: center;

    bottom: 10px;
    position: fixed;
    right: 10px;
    z-index: 99999;

    background-color: ${(0, $0760601060bec790$export$bb40f9313785d264)};
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px ${(0, $0760601060bec790$export$23a1f3ac1c2f685)};
    cursor: default;

    height: 500px;
    padding: 25px;
    width: 350px;
  }

  .public-chat-description {
    color: ${(0, $0760601060bec790$export$926e70b78fead0fe)};
    font-weight: 600;
    text-align: center;
  }

  #public-chat form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }

  #public-chat form section {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0;
    width: 100%;
  }

  #public-chat form section label {
    color: ${(0, $0760601060bec790$export$926e70b78fead0fe)};
    font-size: 14px;
    font-weight: 600;
  }

  #public-chat form section div {
    align-items: center;
    background-color: ${(0, $0760601060bec790$export$5e849c266edab07c).dark};
    border-radius: 10px;
    display: flex;
    height: 40px;
    justify-content: space-between;
    padding: 15px;
    width: 100%;
  }

  #public-chat form section select {
    background: url(https://i.ibb.co/Jvs5jB6/Dropdown-Arrow.png) no-repeat;
    background-position: right 10px top 7.5px;
    background-size: 25px;
    align-items: center;
    background-color: ${(0, $0760601060bec790$export$5e849c266edab07c).dark};
    border-radius: 10px;
    color: ${(0, $0760601060bec790$export$c8df4bc4e3ef7f8e)};
    display: flex;
    font-weight: 500;
    height: 40px;
    justify-content: space-between;
    line-height: 20px;
    padding: 10px;
    width: 100%;
    -moz-appearance: none; 
    -webkit-appearance: none; 
    appearance: none;
  }

  #public-chat form section select option {
    color: ${(0, $0760601060bec790$export$c8df4bc4e3ef7f8e)};
    font-weight: 500;
  }

  #public-chat form  section div input {
    background-color: transparent;
    border: none;
    color: ${(0, $0760601060bec790$export$c8df4bc4e3ef7f8e)};
    font-weight: 500;
    outline: none;
  }

  #public-chat form  section div input::placeholder {
    color: ${(0, $0760601060bec790$export$c8df4bc4e3ef7f8e)};
    opacity: 0.5;
  }

  #public-chat form button {
    background-color: ${(0, $0760601060bec790$export$ecb4d01658531d2e)};
    border: none;
    border-radius: 10px;
    color: ${(0, $0760601060bec790$export$450b76c0a51df89)};
    font-weight: 600;
    height: 40px;
    margin-top: 10px;
    width: 100%;
  }
`;



const $0453581325a2c1bc$export$8821ea1545299efc = (color)=>`
  <svg
    width=30
    height=30
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.66669 17.5L19.1667 10L1.66669 2.5V8.33333L14.1667 10L1.66669 11.6667V17.5Z'
      fill=${color}
    />
  </svg>
`;




const $97d2cb52cb250e86$export$c7f78fe74f534b29 = ({ chatId: chatId  })=>`
  query {
    publicChatMessages(chatId: "${chatId}") {
      data {
        id
        adminId
        chatId
        createdAt
        subject
        text
        type
        waMessageId
        waMessageDateTime
        wppMediaId
        file {
          id
          name
          url
          type
        }
        subscriptionExtraData {
          chatWasClosed
        }
      }
    }
  }
`;


const $c9a6dc2412a0573f$export$16decca878aa4c1d = ({ chatId: chatId  })=>`
  subscription {
    messageAdded(chatId: "${chatId}") {
      id
      adminId
      chatId
      subject
      text
      type
      waMessageDateTime
      waMessageId
      createdAt
      deletedAt
      updatedAt
      file {
        id
        name
        url
        type
      }
      subscriptionExtraData {
        chatWasClosed
      }
    }
  }
`;


const $1062089897ed28f2$export$89036708539255ea = ({ chatId: chatId , text: text  })=>`
  mutation {
    sendAPIClientMessage(
      chatId: "${chatId}"
      text: "${text}"
    ) {
      success
    }
  }
`;





async function $9a4fb30bbdbf5fe2$export$78bcd35e4aaef1a3({ initialMessages: initialMessages = null , section: section  }) {
    await $9a4fb30bbdbf5fe2$var$setChatMessagesSectionAttributes({
        initialMessages: initialMessages,
        section: section
    });
    await $9a4fb30bbdbf5fe2$var$subscriptionHandler(section);
}
async function $9a4fb30bbdbf5fe2$var$setChatMessagesSectionAttributes({ initialMessages: initialMessages = null , section: section  }) {
    let messages = initialMessages;
    if (!messages) {
        const chatId = (0, $22897638eb19270b$export$30a3ed6c591b3762)();
        const query = (0, $97d2cb52cb250e86$export$c7f78fe74f534b29)({
            chatId: chatId
        });
        let chatMessagesData = null;
        try {
            chatMessagesData = await (0, $591003e260097fb2$export$b06728f6e7f99a12)(query);
            const chatAlreadyClosed = chatMessagesData?.errors?.[0]?.message === "CHAT_ALREADY_CLOSED";
            const chatIsNotPublic = chatMessagesData?.errors?.[0]?.message === "CHAT_IS_NOT_PUBLIC";
            if (chatAlreadyClosed || chatIsNotPublic) {
                await $9a4fb30bbdbf5fe2$var$closeChat();
                return;
            }
            messages = chatMessagesData?.data?.publicChatMessages.data.sort().reverse();
        } catch (error) {
            console.error(error);
        }
        if (!chatMessagesData?.data) messages = (0, $22897638eb19270b$export$9a56bf961247f454)();
    }
    section.innerHTML = `
    <style type='text/css'>${0, $bda9123ef1b17172$export$f7a371685c5796cd}</style>
    
    <div class='chat'>
      <div id='messages'>
        ${await $9a4fb30bbdbf5fe2$var$generateChatMessages(messages)}
      </div>

      <form id='send-message-form'>
        <input
          name='message'
          placeholder='Digite aqui...'
          type='text'
        >
        <button>${(0, $0453581325a2c1bc$export$8821ea1545299efc)((0, $0760601060bec790$export$5e849c266edab07c).light)}</button>
      </form>
    </div>
  `;
    await $9a4fb30bbdbf5fe2$var$addFormSubmit();
}
async function $9a4fb30bbdbf5fe2$var$generateChatMessages(initialMessages) {
    let elementMessages = "";
    initialMessages?.slice()?.reverse()?.forEach((message)=>{
        elementMessages += `
        <div class='message ${message.subject === "CLIENT" ? "client" : "admin"}'
        >
          <div><p>${message.text}</p></div>
        </div>
      `;
    });
    return elementMessages;
}
async function $9a4fb30bbdbf5fe2$var$addFormSubmit() {
    const form = document.getElementById("send-message-form");
    form.addEventListener("submit", async (event)=>{
        event.preventDefault();
        const text = event.target.message.value;
        const chatId = (0, $22897638eb19270b$export$30a3ed6c591b3762)();
        const mutation = (0, $1062089897ed28f2$export$89036708539255ea)({
            chatId: chatId,
            text: text
        });
        const response = await (0, $591003e260097fb2$export$b06728f6e7f99a12)(mutation);
        if (response?.data?.sendAPIClientMessage?.success) form.reset();
    });
}
async function $9a4fb30bbdbf5fe2$var$subscriptionHandler(section) {
    const chatId = (0, $22897638eb19270b$export$30a3ed6c591b3762)();
    const subscription = (0, $c9a6dc2412a0573f$export$16decca878aa4c1d)({
        chatId: chatId
    });
    let subscriptionClient = (0, $591003e260097fb2$export$77d98e234285cf80)();
    const connectionStartId = 1;
    function onConnectionStart() {
        const connectionStart = JSON.stringify({
            id: connectionStartId,
            payload: {
                query: subscription,
                variables: {}
            },
            type: "start"
        });
        try {
            subscriptionClient.send(connectionStart);
        } catch (error) {
            console.error("error", error);
        }
    }
    subscriptionClient.onmessage = async (event)=>{
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (data.type === "connection_ack") {
            onConnectionStart();
            return;
        }
        if (event.type === "message" && !!event.data) {
            const messageData = JSON.parse(event.data);
            if (messageData?.payload?.data?.messageAdded) (0, $22897638eb19270b$export$614e007823d2557b)(messageData.payload.data.messageAdded);
            const messages = (0, $22897638eb19270b$export$9a56bf961247f454)();
            await $9a4fb30bbdbf5fe2$var$setChatMessagesSectionAttributes({
                initialMessages: messages,
                section: section
            });
            if (messageData?.payload?.data?.messageAdded?.subscriptionExtraData?.chatWasClosed) {
                const formElement = document.getElementById("send-message-form");
                formElement.setAttribute("style", "display: none");
                setTimeout(async ()=>{
                    await $9a4fb30bbdbf5fe2$var$closeChat();
                }, 10000);
            }
        }
    };
    subscriptionClient.onerror = (error)=>{
        console.error("Error:", error);
    };
    subscriptionClient.onclose = async ()=>{
        const chatId = (0, $22897638eb19270b$export$30a3ed6c591b3762)();
        const chatMessages = (0, $22897638eb19270b$export$9a56bf961247f454)();
        if (chatId && chatMessages) $9a4fb30bbdbf5fe2$var$subscriptionHandler(section);
    };
}
async function $9a4fb30bbdbf5fe2$var$closeChat() {
    (0, $f383eeda273a38ec$export$9c463559d5e131d8)();
    (0, $22897638eb19270b$export$361251948aac9392)();
    (0, $22897638eb19270b$export$9d3459bb89d8aa3b)();
    await (0, $f9ccc1fa0d22629a$export$fdd7009d8ba01295)();
}


const $56159024d4d86ef5$export$4eb47ffd79de600c = (color)=>`
  <svg
    width=30
    height=30
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.75 23.75V6.25C3.75 5.58696 4.01339 4.95107 4.48223 4.48223C4.95107 4.01339 5.58696 3.75 6.25 3.75H23.75C24.413 3.75 25.0489 4.01339 25.5178 4.48223C25.9866 4.95107 26.25 5.58696 26.25 6.25V23.75C26.25 24.413 25.9866 25.0489 25.5178 25.5178C25.0489 25.9866 24.413 26.25 23.75 26.25H6.25C5.58696 26.25 4.95107 25.9866 4.48223 25.5178C4.01339 25.0489 3.75 24.413 3.75 23.75ZM14.9891 7C17.7836 7 19.2698 7.82976 19.6889 8.10871C19.78 8.14632 19.8579 8.2109 19.9128 8.29417C19.9677 8.37743 19.997 8.47557 19.997 8.576C19.9963 8.64305 19.9826 8.70928 19.9568 8.77091C19.931 8.83254 19.8935 8.88834 19.8465 8.93512C19.7996 8.9819 19.744 9.01873 19.6831 9.0435C19.6222 9.06827 19.5571 9.0805 19.4916 9.07947C19.382 9.0804 19.2751 9.04479 19.1871 8.97803L19.1813 8.97406C19.0836 8.90664 17.7855 8.01065 14.9901 8.01065C12.0961 8.01065 10.8138 8.97431 10.7996 8.98513C10.7135 9.04648 10.611 9.0794 10.5061 9.07947C10.4406 9.08059 10.3755 9.06848 10.3146 9.04383C10.2537 9.01918 10.1982 8.98249 10.1512 8.93584C10.1042 8.8892 10.0666 8.83352 10.0407 8.77201C10.0147 8.71049 10.0009 8.64434 10 8.57735C10.0002 8.50589 10.0154 8.4353 10.0444 8.37029C10.0734 8.30528 10.1156 8.24734 10.1683 8.20034C10.171 8.20011 10.1736 8.19891 10.1755 8.19696C10.1942 8.17915 10.2146 8.16329 10.2363 8.14962C10.5659 7.91666 12.0557 7 14.9891 7ZM8.51391 13.3029C8.4231 13.3037 8.33368 13.2805 8.25474 13.2357C8.19685 13.2031 8.14602 13.1594 8.10524 13.107C8.06446 13.0547 8.03454 12.9947 8.01724 12.9306C7.99994 12.8665 7.9956 12.7997 8.00448 12.7339C8.01336 12.6681 8.03528 12.6048 8.06895 12.5476C8.71788 11.4654 10.6923 8.93939 15.0005 8.93939C16.8676 8.93939 18.505 9.42939 19.8652 10.3952C20.9846 11.1879 21.612 12.0852 21.9109 12.5173C21.9488 12.5718 21.9754 12.6333 21.9892 12.6982C22.003 12.7631 22.0036 12.8301 21.991 12.8953C21.9785 12.9604 21.953 13.0224 21.9161 13.0776C21.8793 13.1327 21.8317 13.18 21.7763 13.2165C21.663 13.2913 21.525 13.3191 21.3915 13.294C21.2581 13.2689 21.1397 13.1928 21.0614 13.082C20.5205 12.3048 18.8712 9.9399 15.0005 9.9399C11.2224 9.9399 9.51424 12.1161 8.95786 13.0494C8.91316 13.1273 8.84844 13.1919 8.7704 13.2365C8.69235 13.281 8.60381 13.304 8.51391 13.3029ZM16.9991 22.9858C17.041 22.9957 17.0841 23.0005 17.1272 23C17.2404 23 17.3506 22.964 17.4408 22.8973C17.5311 22.8306 17.5965 22.737 17.6271 22.6306C17.6434 22.5676 17.6466 22.5021 17.6367 22.4379C17.6268 22.3737 17.6039 22.312 17.5693 22.2565C17.5347 22.201 17.4892 22.1527 17.4353 22.1145C17.3814 22.0763 17.3203 22.0489 17.2555 22.0339C14.7483 21.428 13.7015 18.924 13.6211 18.7263C13.5304 18.4055 13.4727 18.0767 13.4488 17.7448C13.4123 17.2684 13.438 16.6117 13.7673 16.1916C14.0089 15.8846 14.397 15.7363 14.9497 15.7363C15.956 15.7363 16.1246 16.2163 16.388 17.212C16.6441 18.1827 16.9954 19.5134 18.95 19.609C19.7003 19.6442 20.3776 19.3194 20.8532 18.698C21.567 17.7662 21.7024 16.3399 21.1974 15.0691C20.8002 14.0737 20.0408 13.0781 19.1111 12.3367C17.9105 11.3835 16.4722 10.8788 14.9497 10.8788C11.6554 10.8788 9.46602 13.0533 8.75662 15.2104C8.10546 17.2008 8.89484 20.088 8.92891 20.2126C8.96665 20.34 9.05406 20.4479 9.17239 20.5131C9.29073 20.5784 9.43057 20.5959 9.56196 20.5618C9.62699 20.5466 9.68825 20.5189 9.74211 20.4802C9.79597 20.4415 9.84135 20.3927 9.87558 20.3367C9.9098 20.2807 9.93217 20.2185 9.94137 20.1539C9.95058 20.0893 9.94642 20.0235 9.92916 19.9605C9.92206 19.9358 9.1826 17.2282 9.7464 15.5057C10.0504 14.5805 10.6818 13.6803 11.4787 13.0428C12.4414 12.2731 13.642 11.8636 14.9486 11.8636C18.0095 11.8636 19.7455 14.1887 20.2347 15.422C20.6154 16.3774 20.5275 17.4598 20.0225 18.1237C19.8357 18.3672 19.5064 18.6532 19.005 18.6284C17.8636 18.5718 17.6653 18.0212 17.3907 16.9728L17.3897 16.9691C17.2593 16.4668 17.124 15.9458 16.787 15.5231C16.3769 15.0042 15.7803 14.7535 14.9534 14.7535C14.0639 14.7535 13.3903 15.0408 12.9475 15.6009C11.9924 16.8151 12.5965 18.8784 12.6352 19.0108L12.6363 19.0146L12.6438 19.0426C12.6914 19.1698 13.8626 22.228 16.9991 22.9858ZM13.1562 23C13.0858 23.0001 13.016 22.9862 12.9512 22.9591C12.8863 22.932 12.8276 22.8921 12.7786 22.842C11.5212 21.5341 10.81 20.0716 10.5423 18.2428V18.2331C10.3921 17.0224 10.612 15.3083 11.6897 14.1298C12.4852 13.2602 13.6035 12.8182 15.0077 12.8182C16.6684 12.8182 17.9735 13.5835 18.7873 15.0279C19.3777 16.0773 19.4948 17.123 19.4978 17.1659C19.504 17.2321 19.497 17.2988 19.4771 17.3623C19.4572 17.4258 19.4249 17.4848 19.382 17.5359C19.3391 17.587 19.2865 17.6292 19.2271 17.6601C19.1677 17.691 19.1027 17.7099 19.036 17.7159C18.9012 17.7304 18.7661 17.6918 18.6598 17.6084C18.5535 17.525 18.4845 17.4035 18.4678 17.2702C18.3787 16.6428 18.1739 16.037 17.8635 15.483C17.2328 14.38 16.2732 13.8193 15.004 13.8193C13.9077 13.8193 13.0499 14.1462 12.4598 14.7918C11.6092 15.7225 11.4447 17.1562 11.5615 18.1046C11.7959 19.7218 12.4229 21.0082 13.5301 22.1579C13.5763 22.2055 13.6124 22.2619 13.6361 22.3236C13.6599 22.3854 13.671 22.4512 13.6686 22.5173C13.6662 22.5833 13.6504 22.6482 13.6222 22.7081C13.594 22.768 13.5539 22.8216 13.5044 22.8659C13.4089 22.9516 13.285 22.9993 13.1562 23ZM16.1216 20.6362C16.8524 21.2411 17.7657 21.5455 18.84 21.5455C19.0782 21.5453 19.3162 21.5311 19.5527 21.5029C19.6179 21.4966 19.6813 21.4772 19.739 21.4456C19.7968 21.4141 19.8478 21.3711 19.8892 21.3192C19.9306 21.2672 19.9614 21.2074 19.9799 21.1431C19.9984 21.0789 20.0042 21.0115 19.997 20.9449C19.9803 20.8102 19.9122 20.6876 19.8074 20.6041C19.7027 20.5206 19.5699 20.4829 19.438 20.4993C18.335 20.6261 17.4398 20.409 16.7701 19.8619C15.664 18.9545 15.4987 17.394 15.4884 17.2966C15.4881 17.2943 15.488 17.2928 15.4879 17.2922C15.4775 17.1557 15.4146 17.0289 15.3129 16.9399C15.2112 16.8508 15.0791 16.8067 14.9456 16.8173C14.8121 16.8279 14.6882 16.8923 14.6012 16.9963C14.5141 17.1003 14.471 17.2354 14.4813 17.372L14.4815 17.3734C14.4903 17.4749 14.6606 19.4322 16.1216 20.6362Z'
      fill=${color}
    />
  </svg>
`;


const $f65d08e3d58ecbc4$export$ba1bb40d56a124e7 = (color)=>`
  <svg
    width=30
    height=30
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 3.33333C10.8841 3.33333 11.7319 3.68452 12.357 4.30964C12.9822 4.93476 13.3333 5.78261 13.3333 6.66666C13.3333 7.55072 12.9822 8.39856 12.357 9.02368C11.7319 9.64881 10.8841 9.99999 10 9.99999C9.11595 9.99999 8.26811 9.64881 7.64299 9.02368C7.01787 8.39856 6.66668 7.55072 6.66668 6.66666C6.66668 5.78261 7.01787 4.93476 7.64299 4.30964C8.26811 3.68452 9.11595 3.33333 10 3.33333ZM10 11.6667C13.6833 11.6667 16.6667 13.1583 16.6667 15V16.6667H3.33334V15C3.33334 13.1583 6.31668 11.6667 10 11.6667Z'
      fill=${color}
    />
  </svg>
`;




const $48d4fb6a7108ea3d$export$d10eeaae03968e17 = ()=>`
  query {
    departments (
      where: {
        deletedAt: null
      }
    ) {
      id
      displayInBot
      name
    }
  }
`;



async function $d7612434e98244d1$export$3078f60c48ffb2b2({ section: section , submitForm: submitForm  }) {
    const formLayout = await $d7612434e98244d1$var$generateFormLayout();
    section.innerHTML = `
    <style type='text/css'>${0, $bda9123ef1b17172$export$55e3a752d0357364}</style>
    <script src='https://unpkg.com/imask'></script>

    <p class='public-chat-description'>Olá. Para iniciar o atendimento via chat preencha o formulário abaixo.</p>
    ${formLayout}
  `;
    $d7612434e98244d1$var$generateFormScripts(submitForm);
    section.setAttribute("style", "");
}
async function $d7612434e98244d1$var$generateFormLayout() {
    const query = (0, $48d4fb6a7108ea3d$export$d10eeaae03968e17)();
    const response = await (0, $591003e260097fb2$export$b06728f6e7f99a12)(query);
    let departmentOptions = "";
    response?.data?.departments?.forEach((department)=>{
        if (!department?.displayInBot) return;
        departmentOptions += `
      <option value="${department.id}">${department.name}</option>
    `;
    });
    return `
    <form id='public-chat-form'>
      <section>
        <label for='name'>
          Nome:
        </label>
        <div>
          <input
            name='name'
            placeholder='Nome'
            type='text'
          >
          ${(0, $f65d08e3d58ecbc4$export$ba1bb40d56a124e7)("#FFFFFF")}
        </div>
      </section>
          
      <section>
        <label for='cpf'>
          CPF:
        </label>
        <div>
          <input
            name='cpf'
            placeholder='CPF'
            type='text'
          >
          ${(0, $56159024d4d86ef5$export$4eb47ffd79de600c)("#FFFFFF")}
        </div>
      </section>
          
      <section>
        <label for='department'>
          Setor:
        </label>
        <select name="department">
          <option value="" disabled selected>Escolha um setor...</option>
          ${departmentOptions}
        </select>
      </section>

      <button type='submit'>Enviar</button>
    </form>
  `;
}
function $d7612434e98244d1$var$generateFormScripts(submitForm) {
    const inputCpf = document.getElementsByName("cpf")[0];
    inputCpf.addEventListener("keyup", (e)=>{
        const initialValue = e.target.value;
        const onlyNumberValue = initialValue.replace(/\D/g, "");
        const maskedValue = (0, $0126659c94792a9b$export$c27c630f90de7078)("000.000.000-00", onlyNumberValue);
        inputCpf.value = maskedValue;
    });
    const form = document.getElementById("public-chat-form");
    form.addEventListener("submit", (event)=>{
        event.preventDefault();
        const submitData = {};
        submitData[event.target.cpf.name] = event.target.cpf.value;
        submitData[event.target.department.name] = event.target.department.value;
        submitData[event.target.name.name] = event.target.name.value;
        submitForm(submitData);
    });
}


let $f383eeda273a38ec$var$clicked = false;
let $f383eeda273a38ec$var$section = null;
let $f383eeda273a38ec$var$showChat = false;
async function $f383eeda273a38ec$export$450aedff397eea2f() {
    const documentExists = !!document;
    if (!documentExists) return;
    $f383eeda273a38ec$var$section = document.getElementById("public-chat");
    await $f383eeda273a38ec$export$b945fc29d352ec53();
    $f383eeda273a38ec$var$section.addEventListener("click", ()=>{
        if ($f383eeda273a38ec$var$clicked) return;
        $f383eeda273a38ec$var$clicked = !$f383eeda273a38ec$var$clicked;
        $f383eeda273a38ec$export$b945fc29d352ec53();
    });
}
function $f383eeda273a38ec$export$9c463559d5e131d8() {
    $f383eeda273a38ec$var$clicked = false;
    $f383eeda273a38ec$var$showChat = false;
}
async function $f383eeda273a38ec$export$b945fc29d352ec53() {
    const chatIdStorage = (0, $22897638eb19270b$export$30a3ed6c591b3762)();
    const chatExists = chatIdStorage;
    if (chatExists) {
        $f383eeda273a38ec$var$clicked = true;
        $f383eeda273a38ec$var$showChat = true;
    }
    if (!$f383eeda273a38ec$var$clicked) {
        $f383eeda273a38ec$var$setNotClickedSectionAttributes();
        return;
    }
    if (!$f383eeda273a38ec$var$showChat) {
        $f383eeda273a38ec$var$section = document.getElementById("public-chat");
        await (0, $d7612434e98244d1$export$3078f60c48ffb2b2)({
            section: $f383eeda273a38ec$var$section,
            submitForm: $f383eeda273a38ec$var$submitForm
        });
        return;
    }
    (0, $9a4fb30bbdbf5fe2$export$78bcd35e4aaef1a3)({
        section: $f383eeda273a38ec$var$section
    });
}
function $f383eeda273a38ec$var$setNotClickedSectionAttributes() {
    $f383eeda273a38ec$var$section.innerHTML = `
    <style type='text/css'>${0, $bda9123ef1b17172$export$11d476d26c515b92}</style>
    ${(0, $c2cbfd2eb3cfadf4$export$f082a360c4afba79)((0, $0760601060bec790$export$ecb4d01658531d2e))}
  `;
}
async function $f383eeda273a38ec$var$submitForm(submitData) {
    const mutation = (0, $7f4c0c598b81a0c6$export$86b5979e3a4ec943)({
        cpf: (0, $0126659c94792a9b$export$4de63bc21318e316)(submitData.cpf),
        departmentId: submitData.department,
        name: submitData.name
    });
    const response = await (0, $591003e260097fb2$export$b06728f6e7f99a12)(mutation);
    $f383eeda273a38ec$var$showChat = true;
    if (!response?.data) {
        $f383eeda273a38ec$export$9c463559d5e131d8();
        return;
    }
    const chatId = response.data.startAPIChat.chatId;
    (0, $22897638eb19270b$export$a6349eb46da4948a)(chatId);
    const initialMessage = response.data.startAPIChat.defaultMessage;
    (0, $22897638eb19270b$export$614e007823d2557b)(initialMessage);
    (0, $9a4fb30bbdbf5fe2$export$78bcd35e4aaef1a3)({
        initialMessages: [
            initialMessage
        ],
        section: $f383eeda273a38ec$var$section
    });
}


function $f9ccc1fa0d22629a$export$fdd7009d8ba01295() {
    (0, $f383eeda273a38ec$export$450aedff397eea2f)();
}
$f9ccc1fa0d22629a$export$fdd7009d8ba01295();

})();
//# sourceMappingURL=index.js.map
